// $(document).ready(function(){

if ((typeof jQuery === 'undefined') || (parseFloat(jQuery.fn.jquery) < 1.7)) {
	const jqueryScript = document.createElement('script')
	jqueryScript.src = 'https://code.jquery.com/jquery-3.5.1.min.js';
	jqueryScript.onload = () => {
		$(document).ready(function () {
            console.log("check warranty")
			wkWarranty();
		});
	}
	document.head.append(jqueryScript)

} else {
	$(document).ready(function () {
        console.log("check warranty")
		wkWarranty();
	});
}

function wkWarranty(){
	(function(){
		window.WARRANTY = (function(){
			function WARRANTY (){}
			// https://cdn.jsdelivr.net/momentjs/latest/moment.min.js
			WARRANTY.loadjQuery = function(afterLoad)
			{
				return WARRANTY.loadScript("https://code.jquery.com/jquery-3.6.0.min.js",function()
				{
					return WARRANTY.loadScript("https://cdn.jsdelivr.net/momentjs/latest/moment.min.js",function() 
					{
						return WARRANTY.loadScript("https://code.jquery.com/ui/1.13.2/jquery-ui.min.js",function()
						{
							WARRANTY.$ = jQuery.noConflict(true);
							WARRANTY.loadLink(WARRANTY.api_url+"css/warranty.css");
							WARRANTY.loadLink("https://code.jquery.com/ui/1.13.2/themes/smoothness/jquery-ui.css");
							// WARRANTY.loadLink(WARRANTY.api_url+"css/bootstrap-grid-only-css.css");
							return afterLoad();
						});
					});
				});
			};
			WARRANTY.loadLink = function(url)
			{
				var style;
				style = document.createElement("link");
				style.type = "text/css";
				style.rel = "stylesheet";

				style.href = url;
				return document.getElementsByTagName("head")[0].appendChild(style);

			}
			WARRANTY.loadScript  = function(url,callback)
			{
				var script;
				script = document.createElement("script");
				script.type = "text/javascript";

				if(script.readyState) {
					script.onreadystatechange = function()
					{
						if(script.readyState == "loaded" || script.readyState == "complete")
						{
							script.onreadystatechange = null;
							return callback();
						}
					};
				}
				else {
					script.onload = function()
					{
						return callback();
					};
				}
				script.src = url;
				document.getElementsByTagName("head")[0].appendChild(script);
				return true;
			};
			return WARRANTY;
		})();

	
	WARRANTY.api_url = "https://apps-sp.webkul.com/warranty-management/";
	WARRANTY.shop_name = Shopify.shop;
	WARRANTY.currency = Shopify.money_format;
	WARRANTY.country = Shopify.country;

		WARRANTY.path = window.location.pathname.split('/');
		WARRANTY.handle = WARRANTY.path.pop(-1);
		WARRANTY.page = WARRANTY.path.pop(-2);

		WARRANTY.loadjQuery(function(){
			console.log(WARRANTY.currency);
			if($("#wk_old_warranty").length > 0){
				var order_id= $("#wk_old_warranty").attr("order_id");
				$.ajax({
					type:'POST',
					url : WARRANTY.api_url+"admin/warranty_front_product",
					jsonpCallback :"default_warranty",
					dataType: "jsonp",
					crossDomain: true,
					data:{shop_name:WARRANTY.shop_name, req:1},
					success:function(response){
						if(response["warranty"]){
							$("#wk_old_warranty").html("<button type='button' class='wk_old_warranty_btn btn' style='background-color:"+response["theme_color"]+";'>"+response["warranty"]+"</button>");
						}else{
							$("#wk_old_warranty").html("<button type='button' class='wk_old_warranty_btn btn' style='background-color:#0745b7;'>Add Warranty</button>");
						}
					},
					error:function(response){
						$("#wk_old_warranty").html("<button type='button' class='wk_old_warranty_btn btn' style='background-color:#0745b7;'>Add Warranty</button>");
						console.log(response);
					console.log("something went wrong");
					}
				});
				// var id = $("#wk_old_warranty").attr("customer_id");
				// $("#wk_old_warranty").html("<button type='button' class='wk_old_warranty_btn btn' style='background-color:#0745b7;'>Old Warranty</button>");

				$('body').on('click','.wk_old_warranty_btn',function(){
					// $('.wk_old_warranty_btn').on('click',function(){
					isValidForOldWarranty(order_id);
					$(".wk_product_page").css("cursor", "pointer");
					$(".wk_product_page").css("text-decoration", "underline");
					$('.wk_old_warranty_btn').prop('disabled', true);
					setTimeout(function (){
						window.scrollTo({top: 100, behavior: "smooth"});
					}, 500);
				});
				// localStorage.setItem('customer_email', email_id);
				// localStorage.setItem('customer_id', id);
			}
			
			

			if($("#wk_view_warranty").length > 0){
				var email_id= $("#wk_view_warranty").attr("customer_email");
				var id = $("#wk_view_warranty").attr("customer_id");
				// labels
				$.ajax({
					type:'POST',
					url : WARRANTY.api_url+"admin/warranty_front_product",
					jsonpCallback :"default_warranty",
					dataType: "jsonp",
					crossDomain: true,
					data:{shop_name:WARRANTY.shop_name, req:2},
					success:function(response){
						if(response['view']){
							$("#wk_view_warranty").html("<a href ='pages/warranty-detail' style=' color:#ffffff !important;'><button type='button' class='wk_view_warranty btn' style='background-color:"+response["theme_color"]+";'>"+response["view"]+"</button></a>");
						}else if(response['theme_color']){
							$("#wk_view_warranty").html("<a href ='pages/warranty-detail' style=' color:#ffffff !important;'><button type='button' class='wk_view_warranty btn' style='background-color:"+response["theme_color"]+";'>View Warranty Details</button></a>");
						}else{
							$("#wk_view_warranty").html("<a href ='pages/warranty-detail' style=' color:#ffffff !important;'><button type='button' class='wk_view_warranty btn' style='background-color:#f48042;'>View Warranty Details</button></a>");
						}
					},
					error:function(response){
						$("#wk_view_warranty").html("<a href ='pages/warranty-detail' style=' color:#ffffff !important;'><button type='button' class='wk_view_warranty btn' style='background-color:#f48042;'>View Warranty Details</button></a>");
						console.log(response);
					console.log("something went wrong view warranty");
					}
				});
				// upper labels
				// $("#wk_view_warranty").html("<a href ='pages/warranty-detail' style=' color:#ffffff !important;'><button type='button' class='wk_view_warranty btn' style='background-color:#f48042;'>View Warranty</button></a>");
				localStorage.setItem('customer_email', email_id);
				localStorage.setItem('customer_id', id);
			}

			if($("#wk_warranty_detail").length > 0) {
				var customer_id = $("#wk_warranty_detail").attr("customer_id");
				getWarrantyDetail(customer_id,0,1);
				console.log(customer_id);
			}

			$("body").on('click','.warranty_product_record_li',function(){
				$(this).addClass("intro");
				var record_no = $(this).text();
				if(record_no == '<') {
					var record_no = $(this).next('.warranty_product_record_li').text();
				}
				else if(record_no == '>') {
					var record_no = $(this).prev('.warranty_product_record_li').text();
				}
				if(parseInt(record_no) == 1) {
					var offset = 0;
				}
				else {
					var offset = (parseInt(record_no) - 1)*10;
				}
				var customer_id = $("#wk_warranty_detail").attr("customer_id");
				if(customer_id) {
					getWarrantyDetail(customer_id,offset,record_no);
				}
			});

			$("body").on('click','.claim_warranty_record_li',function(){
				$(this).addClass("intro");
				var record_no = $(this).text();
				if(record_no == '<') {
					var record_no = $(this).next('.claim_warranty_record_li').text();
				}
				else if(record_no == '>') {
					var record_no = $(this).prev('.claim_warranty_record_li').text();
				}
				if(parseInt(record_no) == 1) {
					var offset = 0;
				}
				else {
					var offset = (parseInt(record_no) - 1)*10;
				}
				var customer_id = $("#wk_warranty_detail").attr("customer_id");
				if(customer_id) {
					$.ajax({
						type:'POST',
						url : WARRANTY.api_url+"admin/warranty_front_detail?callback=wk_claim_get_tpl",
						crossDomain: true,
						data:{
							customer_id:customer_id,
							offset:offset,
							record_no:record_no,
							shop_name:WARRANTY.shop_name
						},
						beforeSend: function() {
							$(".wk_front_loader").show();
						},
						success : function(response) {
							$(".wk_claim_warranty").html(response);
							// $("#wk_date_picker").datepicker();
						},
						error:function(response){
							// console.log(response);

							console.log("something went wrong");
						},
						complete: function() {
							$(".wk_front_loader").hide();
						}
					});
				}
			});

			if($(".wk_default_warranty").length > 0) {
				var product_id= $(".wk_default_warranty").attr("product_id");
				var customer_id = $(".wk_default_warranty").attr("customer_id");
				var default_variant = $('.wk_default_warranty').attr('variant_id');

				$("body").on("click","#wkTermsMyButton",function() {
					// wkTermsMyButton.addEventListener("click", function () {
					wkTermsMyPopup.classList.add("wk-terms-show");
				});
				
				$("body").on("click","#wkTermsClosePopup",function() {
					wkTermsMyPopup.classList.remove("wk-terms-show");
				});

				$("body").on("click",".wk_warr_product_page",function() {
					wkTermsMyPopup.classList.remove("wk-terms-show");
				});
				
				window.addEventListener("click", function (event) {
					var wkTermsMyPopup = document.getElementById("wkTermsMyPopup");
					if ((wkTermsMyPopup != "undefined") && (event.target == wkTermsMyPopup)) {
						wkTermsMyPopup.classList.remove("wk-terms-show");
					}
				});
				if(product_id )
				{
					$.ajax({
					type:'POST',
					url : WARRANTY.api_url+"admin/warranty_front_product",
					jsonpCallback :"default_warranty",
					dataType: "jsonp",
					crossDomain: true,
					data:{id_product:product_id,default_variant:default_variant,customer_id:customer_id,shop_name:WARRANTY.shop_name, isoCode:WARRANTY.country},
					success:function(response){
						if(response) {
							$(".wk_default_warranty").html(response);
							var variant_available = $('.wk_default_warranty').attr('variant_available');
							if(variant_available == 'false'){
								$('.wk_extended_warranty_btn').addClass('disable');
								$('.wk_extended_warranty_btn').attr('disabled','disabled');
								$('.wk_warranty_btn').attr('disabled','disabled');
								$('.wk_warranty_btn').removeAttr("href");
								$('.wk_extended_warranty_btn').css({'background':'#ddd','border-color':'#ddd'});
							}
						}
					},
					error:function(response){
						console.log("something went wrong");
					}
					});
				}
			}

			if($(".wk_search_warranty").length > 0) {
				const jqueryScriptAutoComplete = document.createElement('script')
				jqueryScriptAutoComplete.src = 'https://code.jquery.com/ui/1.13.0/jquery-ui.min.js';
				jqueryScriptAutoComplete.onload = () => {
					$(document).ready(function () {
						wkAutoComplete();
					});
				}
				document.head.append(jqueryScriptAutoComplete);


				var customer_email= $(".wk_search_warranty").attr("customer_email");
				$.ajax({
					type:'POST',
					url : WARRANTY.api_url+"admin/warranty_front_detail?callback=wk_get_tpl",
					crossDomain: true,
					data:{
						customer_email:customer_email,
						shop_name:WARRANTY.shop_name
					},
					beforeSend: function() {
						$(".wk_front_loader").show();
					},
					success : function(response) {
						$(".wk_search_warranty").html(response);
						const jqueryScriptAutoComplete = document.createElement('script')
						jqueryScriptAutoComplete.src = 'https://code.jquery.com/ui/1.13.0/jquery-ui.min.js';
						jqueryScriptAutoComplete.onload = () => {
					$(document).ready(function () {
						wkAutoComplete();
					});
				}
				document.head.append(jqueryScriptAutoComplete);
					},
					error:function(response){
						// console.log(response);

						console.log("something went wrong");
					},
					complete: function() {
						$(".wk_front_loader").hide();
					}
				});

				function wkAutoComplete() {
					$(document).ready(function(){
						$('#wk_warranty_autocomplete').autocomplete({
							source: function (request, response) {
								$.ajax({
									url: WARRANTY.api_url+"admin/warranty_front_detail?callback=wk_search_warranty&shop_name="+WARRANTY.shop_name,
									data: { searchterm: request.term },
									dataType:'json',
									success: function (data) {
										if(data) {
											console.log(data.length);
											response($.map(data.slice(0,24), function (item) {
												return {
													label: item.product_name,
													id_product: item.id_product,
													id: item.id
												};
											}));
										} else {
											return false;
										}
														
										if(data.length==0){
											let ProductPicker = WK_PACK_COMBO.fetchProduct();
										}
									}
								});
							},
							minLength:1,       
							create: function () {
								$(this).data('ui-autocomplete')._renderItem = function (ul, item) {
									return $('<li class="wk_warranty_opt_li">')
									.append( "<div>" + item.value +  "</div>" )
									.appendTo(ul);
								};
							},
							select: function (event, ui) {
								console.log(ui.item.id);
								$("#wk_warranty_selected_product_id").val(ui.item.id_product);

								$.ajax({
									url: WARRANTY.api_url+"admin/warranty_front_detail?callback=wk_warranty_plans&shop_name="+WARRANTY.shop_name,
									data: { wk_warranty_id: ui.item.id },
									dataType:'json',
									success: function (data) {
										$(".wk_error_product_name").hide();
										$("#wk_warranty_autocomplete").css("border-color", "#D5D7DA");
										$(".wk_warr_select_warranty").html(data);
										$(".wk_warr_description_warranty").html("");
									}
								});
							}
						})
					});
				}

				function wkComplete (request) {
					$.ajax({
						type:'POST',
						url : WARRANTY.api_url+"admin/warranty_front_detail?callback=wk_search_warranty&shop_name="+WARRANTY.shop_name,
						crossDomain: true,
						data:{
							searchterm:request
						},
						beforeSend: function() {
							$(".wk_front_loader").show();
						},
						success : function(response) {
							// var json_response = JSON.parse(response, true);
							console.log(response);
							$.each(response, function (i) {
								console.log(response[i].product_name);
								// $('<li class="wk_warranty_opt_li">')
								// 	.append( "<div>" + response[i].product_name +  "</div>" )
								// 	.appendTo(this);
							});
						},
						error:function(response){
							// console.log(response);
			
							console.log("something went wrong");
						},
						complete: function() {
							$(".wk_front_loader").hide();
						}
					});
				}


				$("body").on("keyup", "#wk_warranty_autocomplete", function() {
					var wk_warranty_autocomplete = $(this).val();
					if(wk_warranty_autocomplete == "") {
						$(".wk_error_product_name").show();
						$("#wk_warranty_autocomplete").css("border-color", "red");
						$(this).siblings("#wk_warranty_selected_product_id").val("");
						$(".wk_warr_description_warranty").html("");
						$(".wk_warr_select_warranty").html("");
					} else {
						// wkComplete(wk_warranty_autocomplete);
					}
				})
			}

			$("body").on("click", ".wk_warranty_other_platform_nav_bar", function() {
				$(".wk_warranty_other_platform_nav_bar").addClass("wk_nav_active");
				$(".wk_warranty_product_details_nav_bar").removeClass("wk_nav_active");
				$(".wk_claim_warranty_nav_bar").removeClass("wk_nav_active");
				$(".wk_warranty_products_div").html("");


				var customer_id= $("#wk_warranty_detail").attr("customer_id");
				$.ajax({
					type:'POST',
					url : WARRANTY.api_url+"admin/warranty_front_detail?callback=wk_get_tpl",
					crossDomain: true,
					data:{
						customer_id:customer_id,
						shop_name:WARRANTY.shop_name
					},
					beforeSend: function() {
						$(".wk_front_loader").show();
					},
					success : function(response) {
						$(".wk_search_warranty").html(response);
						// $("#wk_date_picker").datepicker();
					},
					error:function(response){
						// console.log(response);

						console.log("something went wrong");
					},
					complete: function() {
						$(".wk_front_loader").hide();
					}
				});

				function wkAutoComplete1() {
					$(document).ready(function(){
						$('#wk_warranty_autocomplete').autocomplete({
							source: function (request, response) {
								$.ajax({
									url: WARRANTY.api_url+"admin/warranty_front_detail?callback=wk_search_warranty&shop_name="+WARRANTY.shop_name,
									data: { searchterm: request.term },
									dataType:'json',
									success: function (data) {
										if(data) {
											console.log(data.length);
											response($.map(data.slice(0,24), function (item) {
												return {
													label: item.product_name,
													id_product: item.id_product,
													id: item.id
												};
											}));
										} else {
											return false;
										}
														
										if(data.length==0){
											let ProductPicker = WK_PACK_COMBO.fetchProduct();
										}
									}
								});
							},
							minLength:1,       
							create: function () {
								$(this).data('ui-autocomplete')._renderItem = function (ul, item) {
									return $('<li class="wk_warranty_opt_li">')
									.append( "<div>" + item.value +  "</div>" )
									.appendTo(ul);
								};
							},
							select: function (event, ui) {
								console.log(ui.item.id);
								$("#wk_warranty_selected_product_id").val(ui.item.id_product);

								$.ajax({
									url: WARRANTY.api_url+"admin/warranty_front_detail?callback=wk_warranty_plans&shop_name="+WARRANTY.shop_name,
									data: { wk_warranty_id: ui.item.id },
									dataType:'json',
									success: function (data) {
										$(".wk_error_product_name").hide();
										$("#wk_warranty_autocomplete").css("border-color", "#D5D7DA");
										$(".wk_warr_select_warranty").html(data);
										$(".wk_warr_description_warranty").html("");
									}
								});
							}
						})
					});
				}

				function wkComplete (request) {
					$.ajax({
						type:'POST',
						url : WARRANTY.api_url+"admin/warranty_front_detail?callback=wk_search_warranty&shop_name="+WARRANTY.shop_name,
						crossDomain: true,
						data:{
							searchterm:request
						},
						beforeSend: function() {
							$(".wk_front_loader").show();
						},
						success : function(response) {

							if($(".wk_custmized_autocomplete").length > 0) {
								$(".wk_custmized_autocomplete").html("");
								$(".wk_custmized_autocomplete").css("display", "block");
								$.each(response, function (i) {
									// console.log(response[i].product_name);
									$('<li class="wk_warranty_opt_li">')
										.append(`<span class="wk_product_name">${response[i].product_name}</span> <input type="hidden" class="wk_selected_warranty_id" value="${response[i].id}"> <input type="hidden" class="wk_selected_product_id" value="${response[i].id_product}">`)
										.appendTo(".wk_custmized_autocomplete");
								});
							} else {
								$("#wk_warranty_autocomplete").after(`<ul class="wk_custmized_autocomplete"></ul>`)
								$.each(response, function (i) {
									// console.log(response[i].product_name);
									$('<li class="wk_warranty_opt_li">')
										.append(`<span class="wk_product_name">${response[i].product_name}</span> <input type="hidden" class="wk_selected_warranty_id" value="${response[i].id}"> <input type="hidden" class="wk_selected_product_id" value="${response[i].id_product}">`)
										.appendTo(".wk_custmized_autocomplete");
								});
							}
						},
						error:function(response){
							// console.log(response);
			
							console.log("something went wrong");
						},
						complete: function() {
							$(".wk_front_loader").hide();
						}
					});
				}


				$("body").on("keyup", "#wk_warranty_autocomplete", function() {
					var wk_warranty_autocomplete = $(this).val();
					if(wk_warranty_autocomplete == "") {
						$(".wk_error_product_name").show();
						$("#wk_warranty_autocomplete").css("border-color", "red");
						$(this).siblings("#wk_warranty_selected_product_id").val("");
						$(".wk_warr_description_warranty").html("");
						$(".wk_warr_select_warranty").html("");
					} else {
						wkComplete(wk_warranty_autocomplete);
					}
				})
			});

			$("body").on("click", ".wk_claim_warranty_nav_bar", function() {
				$(".wk_claim_warranty_nav_bar").addClass("wk_nav_active");
				$(".wk_warranty_other_platform_nav_bar").removeClass("wk_nav_active");
				$(".wk_warranty_product_details_nav_bar").removeClass("wk_nav_active");
				$(".wk_warranty_products_div").html("");
				$(".wk_search_warranty").html("");

				var customer_id= $("#wk_warranty_detail").attr("customer_id");
				$.ajax({
					type:'POST',
					url : WARRANTY.api_url+"admin/warranty_front_detail?callback=wk_claim_get_tpl",
					crossDomain: true,
					data:{
						customer_id:customer_id,
						shop_name:WARRANTY.shop_name
					},
					beforeSend: function() {
						$(".wk_front_loader").show();
					},
					success : function(response) {
						$(".wk_claim_warranty").html(response);
						// $("#wk_date_picker").datepicker();
					},
					error:function(response){
						// console.log(response);

						console.log("something went wrong");
					},
					complete: function() {
						$(".wk_front_loader").hide();
					}
				});

			});

			$("body").on("click", ".wk_warranty_opt_li", function() {
				var wk_warranty_product_id = $(this).find(".wk_selected_warranty_id").val();
				var wk_warranty_product_name = $(this).find(".wk_product_name").text();
				var wk_selected_product_id = $(this).find(".wk_selected_product_id").val();
				// console.log(wk_warranty_product_id);

				$.ajax({
					type:'POST',
					url : WARRANTY.api_url+"admin/warranty_front_detail?callback=wk_warranty_plans",
					crossDomain: true,
					data:{
						wk_warranty_id:wk_warranty_product_id,
						shop_name:WARRANTY.shop_name
					},
					beforeSend: function() {
						$(".wk_front_loader").show();
					},
					success : function(response) {
						// console.log(response);
						$("#wk_warranty_selected_product_id").val(wk_selected_product_id);
						$(".wk_error_product_name").hide();
						$("#wk_warranty_autocomplete").css("border-color", "#D5D7DA");
						$(".wk_warr_select_warranty").html(response);
						$(".wk_warr_description_warranty").html("");
						$("#wk_warranty_autocomplete").val(wk_warranty_product_name);
						$(".wk_custmized_autocomplete").css("display", "none");
					},
					error:function(response){
						console.log("something went wrong");
					},
					complete: function() {
						$(".wk_front_loader").hide();
					}
				});
			})

			$("body").on("click", ".wk_extend_warr_checkbox_opt", function(){
				if($(".wk_extend_warr_checkbox_opt").is(":checked")){
					$(".wk_extend_warr_details").css("display", "block");
					$(".wk_subtotal_price_details").css("display", "block");
				}else{
					$(".wk_extend_warr_details").css("display", "none");
					if($(".wk_damage_warr_checkbox_opt").is(":checked")){
					}else{
						$(".wk_subtotal_price_details").css("display", "none");
					}
				}

				var damage_protection_check_variant_price = 0.00;
				var check_variant_price = 0.00;
				var wk_store_currency = $(".wk_store_currency").val();
				if($(".wk_damage_warr_checkbox_opt").is(":checked")){
					var damage_protection_check_variant_price 	= parseFloat($(".wk_protection_active").find(".damage_protection_check_variant_price").val()).toFixed(2);
					if(!$.isNumeric(damage_protection_check_variant_price)){
						damage_protection_check_variant_price = 0.00;
					}
				}

				if($(".wk_extend_warr_checkbox_opt").is(":checked")){
					var check_variant_price = parseFloat($(".wk_extended_active").find(".check_variant_price").val()).toFixed(2);
				}

				if(damage_protection_check_variant_price && check_variant_price){
					total_price = parseFloat(damage_protection_check_variant_price) + parseFloat(check_variant_price);
				}else if(damage_protection_check_variant_price){
					total_price = damage_protection_check_variant_price;
				}else{
					total_price = check_variant_price;
				}
				$(".wk_total_price").html(wk_store_currency+" "+total_price);
			});

			$("body").on("click", ".wk_warranty_to_select_div", function(){
				$(".wk_error_msg_select_warranty").hide();
				$(this).addClass('wk_active_warranty');
				$(this).siblings('.wk_warranty_to_select_div').removeClass('wk_active_warranty');
				var wk_description = $(this).find(".wk_extend_warranty_description").val();
				$(".wk_warr_description_warranty").html(wk_description);

			})

			$("body").on("click", ".wk_request_for_warranty", function(){
				var wk_product_id 			= ($("#wk_warranty_selected_product_id").val()).trim();
				var wk_platform_name 		= ($("input[name=wk_warranty_platform_name]").val()).trim();
				var wk_platform_order_id 	= ($("input[name=wk_warranty_platform_order_id]").val()).trim();
				var wk_customer_email 		= ($("input[name=wk_warranty_platform_customer_email]").val()).trim();
				var wk_selected_warranty_datepicker 	= $("input[name=wk_warranty_datepicker]").val();
				var wk_min_date = $(".wk_warranty_min_date").val();
				var wk_warranty_datepicker = "";
				var wk_date = "";
				$(".wk_error_msg_bill_size").hide();

				if(wk_selected_warranty_datepicker && (wk_selected_warranty_datepicker != "")){
					var wk_current_date = new Date();
					var wk_m = wk_current_date.getMonth();
					var wk_d = wk_current_date.getDate();
					var wk_y = wk_current_date.getFullYear();
					var wk_date = new Date(wk_y,wk_m,wk_d);
					wk_warranty_datepicker=new Date(wk_selected_warranty_datepicker);
					wk_min_date=new Date(wk_min_date);
				}
				var wk_max_size = 2 * 1024 * 1024; // 2MB in bytes


				var wk_warranty_form_data = new FormData();
				if($(".wk_warranty_platform_file").length > 0) {
					var wk_warranty_bill = $("input[name=wk_warranty_platform_file]")[0].files[0];
					wk_warranty_form_data.append("file", wk_warranty_bill);
				}

				if(!wk_warranty_datepicker || (wk_warranty_datepicker == "") || (wk_date < wk_warranty_datepicker) || (wk_date < wk_min_date) || (wk_min_date > wk_warranty_datepicker)){
					$(".wk_error_msg_date_picker").show();
					$("#wk_date_picker").css("border-color", "red");
					$("#wk_date_picker").val("");
				} else if(($(".wk_warranty_platform_file").length > 0) && (wk_warranty_bill.size > wk_max_size)) {
					$(".wk_error_msg_bill_size").show();
					$(".wk_error_msg_date_picker").hide();
					$(".wk_warranty_platform_file").css("border-color", "red");
					$(".wk_warranty_platform_file").val("");
				} else if(wk_product_id == "") {
					$(".wk_error_msg_date_picker").hide();
					$(".wk_error_msg_bill_size").hide();
					$(".wk_error_product_name").show();
					$("#wk_warranty_autocomplete").css("border-color", "red");
					$("#wk_date_picker").css("border-color", "#D5D7DA");
					$("#wk_warranty_autocomplete").val("");
				} else if(wk_platform_name == "") {
					$(".wk_error_msg_date_picker").hide();
					$(".wk_error_product_name").hide();
					$(".wk_error_msg_name").show();
					$("#wk_date_picker").css("border-color", "#D5D7DA");
					$("#wk_warranty_autocomplete").css("border-color", "#D5D7DA");
					$("input[name=wk_warranty_platform_name]").css("border-color", "red");
				} else if(wk_platform_order_id == "") {
					$(".wk_error_msg_date_picker").hide();
					$(".wk_error_product_name").hide();
					$(".wk_error_msg_name").hide();
					$(".wk_error_msg_order_id").show();
					$("#wk_date_picker").css("border-color", "#D5D7DA");
					$("#wk_warranty_autocomplete").css("border-color", "#D5D7DA");
					$("input[name=wk_warranty_platform_name]").css("border-color", "#D5D7DA");
					$("input[name=wk_warranty_platform_order_id]").css("border-color", "red");
				} else if(wk_customer_email == "") {
					$(".wk_error_msg_date_picker").hide();
					$(".wk_error_product_name").hide();
					$(".wk_error_msg_name").hide();
					$(".wk_error_msg_order_id").hide();
					$("#wk_date_picker").css("border-color", "#D5D7DA");
					$("#wk_warranty_autocomplete").css("border-color", "#D5D7DA");
					$("input[name=wk_warranty_platform_name]").css("border-color", "#D5D7DA");
					$("input[name=wk_warranty_platform_order_id]").css("border-color", "#D5D7DA");
					$("input[name=wk_warranty_platform_customer_email]").css("border-color", "red");
				} else if ($(".wk_active_warranty").length == 0) {
					$(".wk_error_msg_date_picker").hide();
					$(".wk_error_product_name").hide();
					$(".wk_error_msg_name").hide();
					$(".wk_error_msg_order_id").hide();
					$(".wk_error_msg_select_warranty").show();
					$("#wk_date_picker").css("border-color", "#D5D7DA");
					$("#wk_warranty_autocomplete").css("border-color", "#D5D7DA");
					$("input[name=wk_warranty_platform_name]").css("border-color", "#D5D7DA");
					$("input[name=wk_warranty_platform_order_id]").css("border-color", "#D5D7DA");
				} else {
					$(".wk_error_product_name").hide();
					$(".wk_error_msg_date_picker").hide();
					$(".wk_error_msg_name").hide();
					$(".wk_error_msg_order_id").hide();
					$(".wk_error_msg_select_warranty").hide();
					$("#wk_date_picker").css("border-color", "#D5D7DA");
					$("#wk_warranty_autocomplete").css("border-color", "#D5D7DA");
					$("input[name=wk_warranty_platform_name]").css("border-color", "#D5D7DA");
					$("input[name=wk_warranty_platform_order_id]").css("border-color", "#D5D7DA");
					var wk_active_warranty_id 		= ($(".wk_active_warranty").find(".wk_extend_product_warranty_id").val()).trim();
					
					console.log(`wk_product_id ${wk_product_id} wk_active_warranty ${wk_active_warranty_id} wk_platform_name ${wk_platform_name} wk_platform_order_id ${wk_platform_order_id}`);

					wk_warranty_form_data.append("wk_product_id", wk_product_id);
					wk_warranty_form_data.append("wk_active_warranty_id", wk_active_warranty_id);
					wk_warranty_form_data.append("wk_platform_name", wk_platform_name);
					wk_warranty_form_data.append("wk_platform_order_id", wk_platform_order_id);
					wk_warranty_form_data.append("wk_customer_email", wk_customer_email);
					wk_warranty_form_data.append("wk_purchase_date", wk_selected_warranty_datepicker);					

					$.ajax({
						type: 'POST',
						url: WARRANTY.api_url+"admin/warranty_front_detail?callback=wk_request_for_warranty&shop_name="+WARRANTY.shop_name,
						crossDomain: true,
						contentType: false,
						processData: false,   
						data: wk_warranty_form_data,
						beforeSend: function() {
							$(".wk_front_loader").show();
						},
						success: function (response) {
							console.log(response);
							$("#wk_warr_setting_snackbar").text(response.msg);
							$(".wk_request_for_warranty").text(response.msg);
							var x = document.getElementById("wk_warr_setting_snackbar");
							x.className = "show";
							setTimeout(function(){ x.className = x.className.replace("show", ""); window.location.href = '/pages/warranty-detail';}, 3000);
						},
						error: function (response) {
							console.log(response);
						},
						complete: function() {
							$(".wk_front_loader").hide();
						}
					});
				}
			})

		$("body").on("click", ".wk_damage_warr_checkbox_opt", function(){
			if($(".wk_damage_warr_checkbox_opt").is(":checked")){
				$(".wk_damage_warr_details").css("display", "block");
				$(".wk_subtotal_price_details").css("display", "block");
			}else{
				$(".wk_damage_warr_details").css("display", "none");
				if($(".wk_extend_warr_checkbox_opt").is(":checked")){
				}else{
					$(".wk_subtotal_price_details").css("display", "none");
				}
			}

			var damage_protection_check_variant_price =0;
			var check_variant_price = 0;
			var wk_store_currency = $(".wk_store_currency").val();
			if($(".wk_damage_warr_checkbox_opt").is(":checked")){
				var damage_protection_check_variant_price 	= parseFloat($(".wk_protection_active").find(".damage_protection_check_variant_price").val()).toFixed(2);
				if(!$.isNumeric(damage_protection_check_variant_price)){
					damage_protection_check_variant_price = 0.00;
				}
			}

			if($(".wk_extend_warr_checkbox_opt").is(":checked")){
				var check_variant_price = parseFloat($(".wk_extended_active").find(".check_variant_price").val()).toFixed(2);
			}

			if(damage_protection_check_variant_price && check_variant_price){
				total_price = parseFloat(damage_protection_check_variant_price) + parseFloat(check_variant_price);
			}else if(damage_protection_check_variant_price){
				total_price = damage_protection_check_variant_price;
			}else{
				total_price = check_variant_price;
			}
			console.log(total_price);
			$(".wk_total_price").html(wk_store_currency+" "+total_price);
		});

		$('#forDescription').on('click', function(){
			var redirect_page = $('.forDescription').val();
			console.log(redirect_page);
		})
		
		
		$('body').on('click', '.wk_warranty_btn', function(e) {
			e.preventDefault();
			$('.wk_warr_err').hide();
			var href = $(this).attr('href');

			var wk_active_block_v_id 			= $(this).find(".wk_active_block_v_id").val();
			var wk_main_product_v_id 			= $(this).find(".wk_main_product_v_id").val();
			var wk_damage_active_block_v_id 	= $(this).find(".wk_damage_active_block_v_id").val();
			var wk_checkout_properties 			= $(this).find(".wk_checkout_properties").val();
			var wk_checkout_attributes 			= $(this).find(".wk_checkout_attributes").val();
			var wk_redirect_page				= $(this).find(".wk_redirect_page").val();
			var wk_allow_mulitiple_quantity		= $(this).find(".wk_allow_mulitiple_quantity").val();
			var qty_product 					= $("input[name=quantity]").val();
			
			if((qty_product == undefined) || (qty_product == 'undefined') || (qty_product == 'null')) {
				qty_product = 1;
			}
			var qty_product_damage = qty_product;
			var wk_variant_array = checkProduct(wk_main_product_v_id);
			var not_product_exist = false;

			if(wk_variant_array.length > 0) {
				var wk_active_warr = false;
				var wk_active_dam_warr = false;
				console.log(wk_variant_array.includes(wk_active_block_v_id));
				console.log(wk_active_block_v_id);

				console.log(wk_variant_array.includes(wk_damage_active_block_v_id));
				console.log(wk_damage_active_block_v_id);

				for (let i = 0; i < wk_variant_array.length; i++) {
					if(wk_variant_array[i] == wk_active_block_v_id) {
						wk_active_warr = true;
					} else if (wk_damage_active_block_v_id != "") {
						
						if (wk_variant_array[i] == wk_damage_active_block_v_id) {
							wk_active_dam_warr = true;
						}
					}
				}

				if((wk_active_dam_warr == false) && (wk_damage_active_block_v_id != "")) {
					var quantity_product = checkProductQuantity(wk_main_product_v_id);
					qty_product_damage = parseInt(qty_product_damage) + parseInt(quantity_product);
				}
				if((wk_variant_array.length == 2) && (wk_active_warr) && (wk_active_dam_warr)) {
					not_product_exist = true;
				} else if ((wk_variant_array.length == 1) && ((wk_active_warr == true) || (wk_active_dam_warr == true))) {
					not_product_exist = true;
				}
			} else {
				not_product_exist = true;
			}

			if ((wk_main_product_v_id == "") || (wk_allow_mulitiple_quantity == '0')){
				if(Shopify.shop == 'annkeofficial.myshopify.com'){
					if(location.search.substr(9, 14)){
						default_variant = location.search.substr(9, 14);
					}
					href = href.replace(href.substr(15, 14), default_variant);
				}
				
				var redirect_page = $('.redirect_page').val();
				if(redirect_page != 2){
					window.location.href = href;
				}
				var items_and_count = cartDetail();
				if(items_and_count['item_count'] < 2){
					window.location.href = href;
				}
				
				var split_href =  href.split('=');
				variant_id = split_href[1].split('&');
				added_variant = 0;
				$.each(items_and_count['items'], function(index, val) {
					if(val.id == variant_id[0]){
						added_variant = added_variant+1;
						// alert('already added here');
						$('.wk_warr_err').show();
					}
				});
				if(!added_variant){
					window.location.href = href;
				}
			} else if((not_product_exist == true)) {
				if(wk_redirect_page == '1') {
					if ((wk_checkout_attributes != "") && (wk_damage_active_block_v_id != "") && (wk_main_product_v_id != "") && (wk_active_block_v_id != "")) {
						var permalink = '/cart/'+wk_main_product_v_id+':'+qty_product+','+wk_active_block_v_id+':'+qty_product+','+wk_damage_active_block_v_id+':'+qty_product+'?attributes[wk_damage_warranty]=true';
					} 
					else if ((wk_damage_active_block_v_id != "") && (wk_main_product_v_id != "") && (wk_active_block_v_id == "") && (wk_checkout_attributes != "") ) {
						var permalink = '/cart/'+wk_main_product_v_id+':'+qty_product+','+wk_damage_active_block_v_id+':'+qty_product+'?attributes[wk_damage_warranty]=true';
					} 
					else if ((wk_damage_active_block_v_id != "") && (wk_main_product_v_id != "") && (wk_active_block_v_id != "")) {
						var permalink = '/cart/'+wk_main_product_v_id+':'+qty_product+','+wk_active_block_v_id+':'+qty_product+','+wk_damage_active_block_v_id+':'+qty_product+'';
					}
					else if ((wk_damage_active_block_v_id == "") && (wk_main_product_v_id != "") && (wk_active_block_v_id != "")) {
						var permalink = '/cart/'+wk_main_product_v_id+':'+qty_product+','+wk_active_block_v_id+':'+qty_product+',';
					}
					else if ((wk_damage_active_block_v_id == "") && (wk_main_product_v_id != "") && (wk_active_block_v_id == "")) {
						var permalink = '/cart/'+wk_main_product_v_id+':'+qty_product+',';
					}
				}
				else if(wk_redirect_page == '2') {
					if ((wk_checkout_properties != "") && (wk_damage_active_block_v_id != "") && (wk_main_product_v_id != "") && (wk_active_block_v_id != "")) {

						var permalink = `/cart/add?items[0][id]=${wk_main_product_v_id}&items[0][quantity]=${qty_product}&items[1][id]=${wk_active_block_v_id}&items[1][quantity]=${qty_product}&items[1][properties][_wk_main_product_id]=${wk_main_product_v_id}&items[1][properties][_wk_allow_multiple_quantity]=${wk_allow_mulitiple_quantity}&items[2][id]=${wk_damage_active_block_v_id}&items[2][quantity]=${qty_product_damage}&items[2][properties][_wk_main_product_id]=${wk_main_product_v_id}&items[2][properties][_wk_allow_multiple_quantity]=${wk_allow_mulitiple_quantity}`;
					} 
					else if ((wk_damage_active_block_v_id != "") && (wk_main_product_v_id != "") && (wk_active_block_v_id == "") && (wk_checkout_properties != "") ) {
						var permalink = `/cart/add?items[0][id]=${wk_main_product_v_id}&items[0][quantity]=${qty_product}&items[1][id]=${wk_damage_active_block_v_id}&items[1][quantity]=${qty_product_damage}&items[1][properties][_wk_main_product_id]=${wk_main_product_v_id}&items[1][properties][_wk_allow_multiple_quantity]=${wk_allow_mulitiple_quantity}`;
					} 
					else if ((wk_damage_active_block_v_id != "") && (wk_main_product_v_id != "") && (wk_active_block_v_id != "")) {
						var permalink = `/cart/add?items[0][id]=${wk_main_product_v_id}&items[0][quantity]=${qty_product}&items[1][id]=${wk_active_block_v_id}&items[1][quantity]=${qty_product}&items[1][properties][_wk_main_product_id]=${wk_main_product_v_id}&items[1][properties][_wk_allow_multiple_quantity]=${wk_allow_mulitiple_quantity}&items[2][id]=${wk_damage_active_block_v_id}&items[2][quantity]=${qty_product_damage}&items[2][properties][_wk_main_product_id]=${wk_main_product_v_id}&items[2][properties][_wk_allow_multiple_quantity]=${wk_allow_mulitiple_quantity}`;
					}
					else if ((wk_damage_active_block_v_id == "") && (wk_main_product_v_id != "") && (wk_active_block_v_id != "")) {
						var permalink = `/cart/add?items[0][id]=${wk_main_product_v_id}&items[0][quantity]=${qty_product}&items[1][id]=${wk_active_block_v_id}&items[1][quantity]=${qty_product}&items[1][properties][_wk_main_product_id]=${wk_main_product_v_id}&items[1][properties][_wk_allow_multiple_quantity]=${wk_allow_mulitiple_quantity}`;
					}
					else if ((wk_damage_active_block_v_id == "") && (wk_main_product_v_id != "") && (wk_active_block_v_id == "")) {
						var permalink = `/cart/add?items[0][id]=${wk_main_product_v_id}&items[0][quantity]=${qty_product}`;
					}
				}
				window.location.href = permalink;
			} else {
				$('.wk_warr_err').show();
			}
		});


		$(".wk_default_warranty").on('click','.wk_extend_warranty_available span',function() {
			if($(this).hasClass('wk_extend_plus_minus_icon')) {
				$(this).removeClass('wk_extend_plus_minus_icon');
				$(this).addClass('wk_extend_minus_plus_icon');
				$(this).parents('.wk_extend_warranty_part').siblings('.wk_extend_all_warranty').show();
			}
			else if($(this).hasClass('wk_extend_minus_plus_icon')){
				$(this).removeClass('wk_extend_minus_plus_icon');
				$(this).addClass('wk_extend_plus_minus_icon');
				$(this).parents('.wk_extend_warranty_part').siblings('.wk_extend_all_warranty').hide();
			}
		});


		$("body").on('click','.wk_extend_warr_div',function(){
			$(this).addClass('wk_active_block');
			$(this).siblings('.wk_extend_warr_div').removeClass('wk_active_block');
			var theme_color = $(this).parents('.wk_extend_all_warranty').siblings('div').find('.wk_extended_warranty_btn').css('background-color');
			
			$(this).siblings('.wk_extend_warr_div').css({ 'background-color':'#fff','color':'#000' });
			$(this).css({ 'background-color':theme_color,'color':'#fff' });
			$extended_warranty_amount = $(this).siblings('.extended_warranty_price').val();
			default_variant = $(this).parents('.wk_default_warranty').attr('variant_id');
			main_id_variant = $(this).children('.main_id_variant').val();
			if(main_id_variant && default_variant) {
				var redirect_page = $('.redirect_page').val();
				var wk_damage_active_block = $(".wk_damage_active_block").find(".main_id_variant").val();

				if(Shopify.shop == 'annkeofficial.myshopify.com'){
					if(location.search.substr(9, 14)){
						default_variant = location.search.substr(9, 14);
					}
					if(redirect_page == 1){
						if(wk_damage_active_block){
							var permalink = '/cart/'+default_variant+':1,'+wk_damage_active_block+':1,'+main_id_variant+':1';
							$(".wk_active_block_v_id").val(main_id_variant);
							$(".wk_main_product_v_id").val(default_variant);
							$(".wk_damage_active_block_v_id").val(wk_damage_active_block);
						}else{
							var permalink = '/cart/'+default_variant+':1,'+main_id_variant+':1';

							$(".wk_active_block_v_id").val(main_id_variant);
							$(".wk_main_product_v_id").val(default_variant);
						}
					}else if(redirect_page == 2){
						if(wk_damage_active_block){
							var permalink = '/cart/add?id[]='+default_variant+'&id[]='+wk_damage_active_block+'&id[]='+main_id_variant;

							$(".wk_active_block_v_id").val(main_id_variant);
							$(".wk_main_product_v_id").val(default_variant);
							$(".wk_damage_active_block_v_id").val(wk_damage_active_block);

						}else{
							var permalink = '/cart/add?id[]='+default_variant+'&id[]='+main_id_variant;

							$(".wk_active_block_v_id").val(main_id_variant);
							$(".wk_main_product_v_id").val(default_variant);
						}
					}
				}else{
					if(redirect_page == 1){
						if(wk_damage_active_block){
							var permalink = '/cart/'+default_variant+':1,'+wk_damage_active_block+':1,'+main_id_variant+':1';

							$(".wk_active_block_v_id").val(main_id_variant);
							$(".wk_main_product_v_id").val(default_variant);
							$(".wk_damage_active_block_v_id").val(wk_damage_active_block);
							
						}else{
							var permalink = '/cart/'+default_variant+':1,'+main_id_variant+':1';

							$(".wk_active_block_v_id").val(main_id_variant);
							$(".wk_main_product_v_id").val(default_variant);
						}
					}else if(redirect_page == 2){
						if(wk_damage_active_block){

							// var permalink = '/cart/add?id[]='+default_variant+'&id[]='+wk_damage_active_block+'&id[]='+main_id_variant;

							var permalink = `/cart/add?items[0][id]=${default_variant}&items[1][id]=${wk_damage_active_block}&items[1][properties][_wk_main_product_id]=${default_variant}&items[2][id]=${main_id_variant}&items[2][properties][_wk_main_product_id]=${default_variant}`;

							$(".wk_active_block_v_id").val(main_id_variant);
							$(".wk_main_product_v_id").val(default_variant);
							$(".wk_damage_active_block_v_id").val(wk_damage_active_block);
						}else{
							// var permalink = '/cart/add?id[]='+default_variant+'&id[]='+main_id_variant;

							var permalink = `/cart/add?items[0][id]=${default_variant}&items[1][id]=${main_id_variant}&items[1][properties][_wk_main_product_id]=${default_variant}`;

							$(".wk_active_block_v_id").val(main_id_variant);
							$(".wk_main_product_v_id").val(default_variant);
						}
					}
				}
				$(".wk_warranty_btn").attr("href",permalink);
			}else{
				$('.wk_warranty_btn').removeAttr("href");
			}
			$('.wk_extd_des').html($(this).children('.wk_extd_warr_desc').html()).show();
		});


		$("body").on('click','.wk_damage_warr_div',function(){
			$(this).addClass('wk_damage_active_block');
			$(this).siblings('.wk_damage_warr_div').removeClass('wk_damage_active_block');
			$(".wk_damage_active_block_v_id").val('');
			var theme_color = $(this).parents('.wk_damage_all_warranty').siblings('div').find('.wk_extended_warranty_btn').css('background-color');
			$(this).siblings('.wk_damage_warr_div').css({ 'background-color':'#fff','color':'#000' });
			$(this).css({ 'background-color':theme_color,'color':'#fff' });
			$extended_warranty_amount = $(this).siblings('.damage_warranty_price').val();
			default_variant = $(this).parents('.wk_default_warranty').attr('variant_id');
			main_id_variant = $(this).children('.main_id_variant').val();
			if(main_id_variant && default_variant) {
				var redirect_page = $('.redirect_page').val();
				var prev_permalink = $(".wk_warranty_btn").attr("href");
				var wk_active_block = $(".wk_active_block").find(".main_id_variant").val();
				var wk_default_warranty_variant = $(".wk_default_warranty_variant").val();

				if(Shopify.shop == 'annkeofficial.myshopify.com'){
					if(location.search.substr(9, 14)){
						default_variant = location.search.substr(9, 14);
					}
					if(redirect_page == 1){
						if(wk_active_block){
							var permalink = '/cart/'+default_variant+':1,'+wk_active_block+':1,'+main_id_variant+':1';

							$(".wk_active_block_v_id").val(wk_active_block);
							$(".wk_main_product_v_id").val(default_variant);
							$(".wk_damage_active_block_v_id").val(main_id_variant);
							
						}else if(wk_default_warranty_variant){
							var permalink = '/cart/'+default_variant+':1,'+wk_default_warranty_variant+':1,'+main_id_variant+':1';

							$(".wk_active_block_v_id").val(wk_default_warranty_variant);
							$(".wk_main_product_v_id").val(default_variant);
							$(".wk_damage_active_block_v_id").val(main_id_variant);
						}else{
							var permalink = '/cart/'+default_variant+':1,'+main_id_variant+':1?attributes[wk_damage_warranty]=true';

							$(".wk_checkout_attributes").val("wk_damage_warranty");
							$(".wk_main_product_v_id").val(default_variant);
							$(".wk_damage_active_block_v_id").val(main_id_variant);
						}
					}else if(redirect_page == 2){
						if(wk_active_block){
							var permalink = '/cart/add?id[]='+default_variant+'&id[]='+wk_active_block+'&id[]='+main_id_variant;

							$(".wk_active_block_v_id").val(wk_active_block);
							$(".wk_main_product_v_id").val(default_variant);
							$(".wk_damage_active_block_v_id").val(main_id_variant);
						}else if(wk_default_warranty_variant){
							var permalink = '/cart/add?id[]='+default_variant+'&id[]='+wk_default_warranty_variant+'&id[]='+main_id_variant;

							$(".wk_active_block_v_id").val(wk_default_warranty_variant);
							$(".wk_main_product_v_id").val(default_variant);
							$(".wk_damage_active_block_v_id").val(main_id_variant);
						}else{
							var permalink = '/cart/add?id[]='+default_variant+'&id[]='+main_id_variant+'&attributes[wk_damage_warranty]=true';

							$(".wk_checkout_attributes").val("wk_damage_warranty");
							$(".wk_main_product_v_id").val(default_variant);
							$(".wk_damage_active_block_v_id").val(main_id_variant);
						}
					}
				}else{
					if(redirect_page == 1){
						if(wk_active_block){
							var permalink = '/cart/'+default_variant+':1,'+wk_active_block+':1,'+main_id_variant+':1';

							$(".wk_active_block_v_id").val(wk_active_block);
							$(".wk_main_product_v_id").val(default_variant);
							$(".wk_damage_active_block_v_id").val(main_id_variant);

						}else if(wk_default_warranty_variant){
							var permalink = '/cart/'+default_variant+':1,'+wk_default_warranty_variant+':1,'+main_id_variant+':1';

							$(".wk_active_block_v_id").val(wk_default_warranty_variant);
							$(".wk_main_product_v_id").val(default_variant);
							$(".wk_damage_active_block_v_id").val(main_id_variant);
						}else{
							var permalink = '/cart/'+default_variant+':1,'+main_id_variant+':1?attributes[wk_damage_warranty]=true';

							$(".wk_checkout_attributes").val("wk_damage_warranty");
							$(".wk_main_product_v_id").val(default_variant);
							$(".wk_damage_active_block_v_id").val(main_id_variant);
						}
					}else if(redirect_page == 2){
						if(wk_active_block){
							// var permalink = '/cart/add?id[]='+default_variant+'&id[]='+wk_active_block+'&id[]='+main_id_variant;

							var permalink = `/cart/add?items[0][id]=${default_variant}&items[1][id]=${wk_active_block}&items[1][properties][_wk_main_product_id]=${default_variant}&items[2][id]=${main_id_variant}&items[2][properties][_wk_main_product_id]=${default_variant}`;

							$(".wk_active_block_v_id").val(wk_active_block);
							$(".wk_main_product_v_id").val(default_variant);
							$(".wk_damage_active_block_v_id").val(main_id_variant);
							$(".wk_checkout_properties").val("_wk_main_product_id");
						}else if(wk_default_warranty_variant){
							// var permalink = '/cart/add?id[]='+default_variant+'&id[]='+wk_default_warranty_variant+'&id[]='+main_id_variant;

							var permalink = `/cart/add?items[0][id]=${default_variant}&items[1][id]=${wk_default_warranty_variant}&items[1][properties][_wk_main_product_id]=${default_variant}&items[2][id]=${main_id_variant}&items[2][properties][_wk_main_product_id]=${default_variant}`;

							$(".wk_active_block_v_id").val(wk_default_warranty_variant);
							$(".wk_main_product_v_id").val(default_variant);
							$(".wk_damage_active_block_v_id").val(main_id_variant);
							$(".wk_checkout_properties").val("_wk_main_product_id");
						}else{
							// var permalink = '/cart/add?id[]='+default_variant+'&id[]='+main_id_variant+'&attributes[wk_damage_warranty]=true';

							var permalink = `/cart/add?items[0][id]=${default_variant}&items[1][id]=${main_id_variant}&items[1][properties][_wk_main_product_id]=${default_variant}&attributes[wk_damage_warranty]=true`;


							$(".wk_main_product_v_id").val(default_variant);
							$(".wk_damage_active_block_v_id").val(main_id_variant);
							$(".wk_checkout_properties").val("_wk_main_product_id");
							$(".wk_checkout_attributes").val("wk_damage_warranty");
						}
					}
				}
				$(".wk_warranty_btn").attr("href",permalink);
			}else{
				$('.wk_warranty_btn').removeAttr("href");
			}
			$('.wk_damage_des').html($(this).children('.wk_damage_warr_desc').html()).show();
		});

		$("body").on('click', '.wk_extended_warranty_btn', function(e){
			e.preventDefault();
			var wk_active_block 				= $(".wk_active_block").find(".main_id_variant").val();
			var wk_main_id_variant 				= $('.wk_default_warranty').attr("variant_id");
			var wk_damage_active_block 			= $(".wk_damage_active_block").find(".main_id_variant").val();
			var wk_default_warranty_variant 	= $(".wk_default_warranty_variant").val();
			var redirect_page 					= $('.redirect_page').val();
			var wk_warranty_btn 				= $(".wk_warranty_btn").attr("href");
		});


		if(WARRANTY.handle == 'cart' || WARRANTY.page == 'cart'){
			function getCart() {
				let wk_is_remove = false;
				let shop_base_url = location.origin;
				jQuery.ajax({
					type: 'GET',
					url: shop_base_url+"/cart.js",
					dataType: "json",
					contentType: "application/json",
					async: false,
					success: function (response) {
						response.items.forEach(element => {
							console.log(`product id is ${element.properties._wk_main_product_id}`);
							if(element.properties != undefined && element.properties != null && element.properties._wk_main_product_id != undefined && element.properties._wk_main_product_id != null){
								var wk_product_id = element.properties._wk_main_product_id;

								var _wk_allow_multiple_quantity = element.properties._wk_allow_multiple_quantity;
								var wk_cart_quantity = element.quantity;

								var wkCheckInCart = checkInCart(wk_product_id, _wk_allow_multiple_quantity, wk_cart_quantity);
								if(wkCheckInCart == false){
									console.log(`wkCheckInCart should be ${wkCheckInCart}`);
									removeItem(element.id);
									wk_is_remove = true;
								} else if (_wk_allow_multiple_quantity == '1') {
									if (wkCheckInCart == "true") {

									} else {
										removeItem(element.id, _wk_allow_multiple_quantity, wkCheckInCart);
										wk_is_remove = true;
									}
								}
							}
						});
					}
				});

				if(wk_is_remove){
					setTimeout(function () {
						window.open("/cart", "_top");
					}, 500);
				}
			}

			function checkInCart(wk_prod_id=false, _wk_allow_multiple_quantity=0, wk_cart_quantity=0) {
				let wk_item_check = false;
				let shop_base_url = location.origin;
				jQuery.ajax({
					type: 'GET',
					url: shop_base_url+"/cart.js",
					dataType: "json",
					contentType: "application/json",
					async: false,
					success: function (response) {
						response.items.forEach(element => {
							if((_wk_allow_multiple_quantity==0) && (wk_prod_id == element.id)){
								wk_item_check="true";
							} else if((_wk_allow_multiple_quantity=='1') && (wk_prod_id == element.id)) {
								if (wk_cart_quantity == element.quantity) {
									wk_item_check = "true";
								} else if(wk_cart_quantity != element.quantity) {
									wk_item_check = element.quantity;
								}
							}
						});
					}
				});
				return wk_item_check;
			}

			function removeItem(variantId, _wk_allow_multiple_quantity=0, required_qty=0) {
				let shop_base_url = location.origin;
				$.ajax({
					type: "POST",
					url: shop_base_url+"/cart/change.js",
					dataType: "json",
					data: {
						id: parseFloat(variantId),
						quantity: required_qty,
					},
				}).then((data) => {
					cartBtn.textContent = "Add to cart";
					cartBtn.removeAttribute("data-variant-id");
				});
			}
			getCart();
		}
		

		$("body").on('click','.wk_extend_warr_divs>.extend_checkbox',function(){
			if(this.checked) {
				$(this).addClass('wk_check_block');
				$(this).parents('.wk_extend_warr_divs').siblings('.wk_extend_warr_divs').children('.extend_checkbox').prop("checked", false);
			}else{
				$(this).prop("checked", true);
			}

			$(this).parent(".wk_extend_warr_divs").addClass('wk_active_block');
			$(this).parent(".wk_extend_warr_divs").siblings('.wk_extend_warr_divs').removeClass('wk_active_block');
			$(this).parent(".wk_extend_warr_divs").siblings('.wk_extend_warr_divs').find('.extend_checkbox').prop("checked", false);
			
			$(this).siblings('.wk_extend_warr_div').css({ 'background-color':'#fff','color':'#000' });
			$(this).css({ 'background-color':'#F56659','color':'#fff' });

			$extended_warranty_amount = $(this).siblings('.extended_warranty_price').val();
			default_variant = $(this).parents('.wk_default_warranty').attr('variant_id');
			main_id_variant = $(this).siblings('.main_id_variant').val();
			if(main_id_variant && default_variant) {
			// var permalink = '/cart/'+default_variant+':1,'+main_id_variant+':1';
			var wk_damage_active_block = $(".wk_damage_active_block").find(".main_id_variant").val();
			var redirect_page = $('.redirect_page').val();
			if(redirect_page == 1){
				if(wk_damage_active_block){
					var permalink = '/cart/'+default_variant+':1,'+main_id_variant+':1,'+wk_damage_active_block+':1';


					$(".wk_active_block_v_id").val(main_id_variant);
					$(".wk_main_product_v_id").val(default_variant);
					$(".wk_damage_active_block_v_id").val(wk_damage_active_block);
				}else{
					var permalink = '/cart/'+default_variant+':1,'+main_id_variant+':1';


					$(".wk_active_block_v_id").val(main_id_variant);
					$(".wk_main_product_v_id").val(default_variant);
				}
			}else if(redirect_page == 2){
				if(wk_damage_active_block){
					// var permalink = '/cart/add?id[]='+default_variant+'&id[]='+main_id_variant+'&id[]='+wk_damage_active_block;

					var permalink = `/cart/add?items[0][id]=${default_variant}&items[1][id]=${wk_damage_active_block}&items[1][properties][_wk_main_product_id]=${default_variant}&items[2][id]=${main_id_variant}&items[2][properties][_wk_main_product_id]=${default_variant}`;


					$(".wk_active_block_v_id").val(main_id_variant);
					$(".wk_main_product_v_id").val(default_variant);
					$(".wk_damage_active_block_v_id").val(wk_damage_active_block);
					$(".wk_checkout_properties").val("_wk_main_product_id");
				}else{
					// var permalink = '/cart/add?id[]='+default_variant+'&id[]='+main_id_variant;

					var permalink = `/cart/add?items[0][id]=${default_variant}&items[1][id]=${main_id_variant}&items[1][properties][_wk_main_product_id]=${default_variant}`;

					$(".wk_active_block_v_id").val(main_id_variant);
					$(".wk_main_product_v_id").val(default_variant);
					$(".wk_checkout_properties").val("_wk_main_product_id");
				}
			}
			$(".wk_warranty_btn").attr("href",permalink);
			}else{
			$('.wk_warranty_btn').removeAttr("href");
			}
			$('.wk_extd_des').html($(this).siblings('.wk_extd_warr_desc').html()).show();
		});

		// $("body").on('click','.wk_check_block',function(){
			// 	$(this).removeClass('wk_check_block');
			// 	$(this).prop("checked", false);
			// 	$(this).parents('.wk_extend_warr_divs').siblings('.wk_extend_warr_divs').children('.extend_checkbox').prop("checked", false);
			// 	$extended_warranty_amount = $(this).siblings('.extended_warranty_price').val();
			// 	default_variant = $(this).parents('.wk_default_warranty').attr('variant_id');
			// 	main_id_variant = $('.default_warranty_main_id_variant').val();
			// 	if(main_id_variant && default_variant) {
			// 	// var permalink = '/cart/'+default_variant+':1,'+main_id_variant+':1';
			// 	var wk_damage_active_block = $(".wk_damage_active_block").find(".main_id_variant").val();
			// 	var redirect_page = $('.redirect_page').val();
			// 	if(redirect_page == 1){
			// 		if(wk_damage_active_block){
			// 			var permalink = '/cart/'+default_variant+':1,'+main_id_variant+':1,'+wk_damage_active_block+':1';
			// 		}else{
			// 			var permalink = '/cart/'+default_variant+':1,'+main_id_variant+':1';
			// 		}
			// 	}else if(redirect_page == 2){
			// 		if(wk_damage_active_block){
			// 			var permalink = '/cart/add?id[]='+default_variant+'&id[]='+main_id_variant+'&id[]='+wk_damage_active_block;
			// 		}else{
			// 			var permalink = '/cart/add?id[]='+default_variant+'&id[]='+main_id_variant;
			// 		}
			// 	}
			// 	$(".wk_warranty_btn").attr("href",permalink);
			// 	}else{
			// 	$('.wk_warranty_btn').removeAttr("href");
			// 	}
			// 	$('.wk_extd_des').html($(this).siblings('.wk_extd_warr_desc').html()).show();

		// });

		// Damage Warranty js for check box
		$("body").on('click','.wk_damage_warr_divs>.extend_checkbox',function(){
			if(this.checked) {
				$(this).addClass('wk_check_block');
				$(this).parents('.wk_extend_warr_divs').siblings('.wk_extend_warr_divs').children('.extend_checkbox').prop("checked", false);
			}else{
				$(this).prop("checked", true);
			}


			$(this).parent(".wk_damage_warr_divs").addClass('wk_damage_active_block');
			$(this).parent(".wk_damage_warr_divs").siblings('.wk_damage_warr_divs').removeClass('wk_damage_active_block');
			$(".wk_damage_active_block_v_id").val('');
			$(this).parent(".wk_damage_warr_divs").siblings('.wk_damage_warr_divs').find('.extend_checkbox').prop("checked", false);
			

			$(this).siblings('.wk_extend_warr_div').css({ 'background-color':'#fff','color':'#000' });
			$(this).css({ 'background-color':'#F56659','color':'#fff' });

			$extended_warranty_amount = $(this).siblings('.damage_warranty_price').val();
			default_variant = $(this).parents('.wk_default_warranty').attr('variant_id');
			main_id_variant = $(this).siblings('.main_id_variant').val();
			if(main_id_variant && default_variant) {
			// var permalink = '/cart/'+default_variant+':1,'+main_id_variant+':1';
			var redirect_page = $('.redirect_page').val();

			var prev_permalink = $(".wk_warranty_btn").attr("href");
			var wk_active_block = $(".wk_active_block").find(".main_id_variant").val();
			var wk_default_warranty_variant = $(".wk_default_warranty_variant").val();
			
			
			if(redirect_page == 1){
				if(wk_active_block){
					var permalink = '/cart/'+default_variant+':1,'+wk_active_block+':1,'+main_id_variant+':1';
					
					$(".wk_active_block_v_id").val(wk_active_block);
					$(".wk_main_product_v_id").val(default_variant);
					$(".wk_damage_active_block_v_id").val(main_id_variant);
				}else if(wk_default_warranty_variant){
					var permalink = '/cart/'+default_variant+':1,'+wk_default_warranty_variant+':1,'+main_id_variant+':1';

					$(".wk_active_block_v_id").val(wk_default_warranty_variant);
					$(".wk_main_product_v_id").val(default_variant);
					$(".wk_damage_active_block_v_id").val(main_id_variant);
				}else{
					var permalink = '/cart/'+default_variant+':1,'+main_id_variant+':1?attributes[wk_damage_warranty]=true';

					$(".wk_checkout_attributes").val("wk_damage_warranty");
					$(".wk_main_product_v_id").val(default_variant);
					$(".wk_damage_active_block_v_id").val(main_id_variant);
				}
			}else if(redirect_page == 2){
				if(wk_active_block){
					// var permalink = '/cart/add?id[]='+default_variant+'&id[]='+wk_active_block+'&id[]='+main_id_variant;

					var permalink = `/cart/add?items[0][id]=${default_variant}&items[1][id]=${wk_active_block}&items[1][properties][_wk_main_product_id]=${default_variant}&items[2][id]=${main_id_variant}&items[2][properties][_wk_main_product_id]=${default_variant}`;

					$(".wk_active_block_v_id").val(wk_active_block);
					$(".wk_main_product_v_id").val(default_variant);
					$(".wk_damage_active_block_v_id").val(main_id_variant);

				}else if(wk_default_warranty_variant){
					// var permalink = '/cart/add?id[]='+default_variant+'&id[]='+wk_default_warranty_variant+'&id[]='+main_id_variant;

					var permalink = `/cart/add?items[0][id]=${default_variant}&items[1][id]=${wk_default_warranty_variant}&items[1][properties][_wk_main_product_id]=${default_variant}&items[2][id]=${main_id_variant}&items[2][properties][_wk_main_product_id]=${default_variant}`;

					$(".wk_active_block_v_id").val(wk_default_warranty_variant);
					$(".wk_main_product_v_id").val(default_variant);
					$(".wk_damage_active_block_v_id").val(main_id_variant);
					$(".wk_checkout_properties").val("_wk_main_product_id");
				}else{
					// var permalink = '/cart/add?id[]='+default_variant+'&id[]='+main_id_variant+'&attributes[wk_damage_warranty]=true';

					var permalink = `/cart/add?items[0][id]=${default_variant}&items[1][id]=${main_id_variant}&items[1][properties][_wk_main_product_id]=${default_variant}&attributes[wk_damage_warranty]=true`;

					$(".wk_main_product_v_id").val(default_variant);
					$(".wk_damage_active_block_v_id").val(main_id_variant);
					$(".wk_checkout_properties").val("_wk_main_product_id");
				}
			}
			
			$(".wk_warranty_btn").attr("href",permalink);
			}else{
			$('.wk_warranty_btn').removeAttr("href");
			}
			$('.wk_damage_des').html($(this).siblings('.wk_damage_warr_desc').html()).show();
		});
		// check box
		

		$("body").on('click','.wk_active_block',function(){
			$(this).removeClass('wk_active_block');
			var theme_color = $(this).parents('.wk_extend_all_warranty').siblings('div').find('.wk_extended_warranty_btn').css('background-color');
			$(this).siblings('.wk_extend_warr_div').css({ 'background-color':'#fff','color':'#000' });
			$(this).css({ 'background-color':'transparent','color':'#000' });

			$(this).find('.extend_checkbox').prop("checked", false);
			
			$extended_warranty_amount = $(this).siblings('.extended_warranty_price').val();
			default_variant = $(this).parents('.wk_default_warranty').attr('variant_id');
			main_id_variant = $('.default_warranty_main_id_variant').val();
			if(!main_id_variant){
				main_id_variant = $('.wk_default_warranty_main_id_variant_free').val();
			}

			var wk_damage_active_block = $(".wk_damage_active_block").find(".main_id_variant").val();

			if(main_id_variant || default_variant) {
			var redirect_page = $('.redirect_page').val();

			if(redirect_page == 1){
				if(wk_damage_active_block && main_id_variant){
					var permalink = '/cart/'+default_variant+':1,'+main_id_variant+':1,'+wk_damage_active_block+':1';

					$(".wk_active_block_v_id").val(main_id_variant);
					$(".wk_main_product_v_id").val(default_variant);
					$(".wk_damage_active_block_v_id").val(wk_damage_active_block);
				}else if(wk_damage_active_block){
					var permalink = '/cart/'+default_variant+':1,'+wk_damage_active_block+':1';

					$(".wk_main_product_v_id").val(default_variant);
					$(".wk_damage_active_block_v_id").val(wk_damage_active_block);
				}else{
					if(main_id_variant){
						var permalink = '/cart/'+default_variant+':1,'+main_id_variant+':1';

						$(".wk_active_block_v_id").val(main_id_variant);
						$(".wk_main_product_v_id").val(default_variant);
					}else{
						var permalink = '/cart/'+default_variant+':1,';

						$(".wk_main_product_v_id").val(default_variant);
					}
				}
			}else if(redirect_page == 2){
				if(wk_damage_active_block && main_id_variant){
					// var permalink = '/cart/add?id[]='+default_variant+'&id[]='+main_id_variant+'&id[]='+wk_damage_active_block;


					var permalink = `/cart/add?items[0][id]=${default_variant}&items[1][id]=${wk_damage_active_block}&items[1][properties][_wk_main_product_id]=${default_variant}&items[2][id]=${main_id_variant}&items[2][properties][_wk_main_product_id]=${default_variant}`;

					$(".wk_active_block_v_id").val(main_id_variant);
					$(".wk_main_product_v_id").val(default_variant);
					$(".wk_damage_active_block_v_id").val(wk_damage_active_block);
					$(".wk_checkout_properties").val("_wk_main_product_id");
				}else if(wk_damage_active_block){
					// var permalink = '/cart/add?id[]='+default_variant+'&id[]='+wk_damage_active_block;

					var permalink = `/cart/add?items[0][id]=${default_variant}&items[1][id]=${wk_damage_active_block}&items[1][properties][_wk_main_product_id]=${default_variant}`;


					$(".wk_checkout_properties").val("_wk_main_product_id");
					$(".wk_main_product_v_id").val(default_variant);
					$(".wk_damage_active_block_v_id").val(wk_damage_active_block);
				}else{
					if(main_id_variant){
						// var permalink = '/cart/add?id[]='+default_variant+'&id[]='+main_id_variant;


						var permalink = `/cart/add?items[0][id]=${default_variant}&items[1][id]=${main_id_variant}&items[1][properties][_wk_main_product_id]=${default_variant}`;

						$(".wk_active_block_v_id").val(main_id_variant);
						$(".wk_main_product_v_id").val(default_variant);
						$(".wk_checkout_properties").val("_wk_main_product_id");
					}else{
						var permalink = '/cart/add?id[]='+default_variant;

						$(".wk_main_product_v_id").val(default_variant);
					}
				}
			}
			
			$(".wk_warranty_btn").attr("href",permalink);
			}else{
			$('.wk_warranty_btn').removeAttr("href");
			}
			$('.wk_extd_des').html($(this).children('.wk_extd_warr_desc').html()).hide();
		});

		$("body").on('click','.wk_damage_active_block',function(){
			$(this).removeClass('wk_damage_active_block');
			$(".wk_damage_active_block_v_id").val('');
			var theme_color = $(this).parents('.wk_damage_all_warranty').siblings('div').find('.wk_extended_warranty_btn').css('background-color');
			$(this).siblings('.wk_damage_warr_div').css({ 'background-color':'#fff','color':'#000' });
			$(this).css({ 'background-color':'transparent','color':'#000' });
			$extended_warranty_amount = $(this).siblings('.damage_warranty_price').val();
			default_variant = $(this).parents('.wk_default_warranty').attr('variant_id');
			main_id_variant = $('.default_warranty_main_id_variant').val();
			if(!main_id_variant){
			main_id_variant = $('.wk_default_warranty_main_id_variant_free').val();
			}

			$(this).find('.extend_checkbox').prop("checked", false);

			var wk_active_block = $(".wk_active_block").find(".main_id_variant").val();

			if(main_id_variant || default_variant) {
			var redirect_page = $('.redirect_page').val();
			if(redirect_page == 1){
				if(wk_active_block){
					var permalink = '/cart/'+default_variant+':1,'+wk_active_block+':1';

					$(".wk_active_block_v_id").val(wk_active_block);
					$(".wk_main_product_v_id").val(default_variant);
				}else{
					if(main_id_variant){
						var permalink = '/cart/'+default_variant+':1,'+main_id_variant+':1';

						$(".wk_active_block_v_id").val(main_id_variant);
						$(".wk_main_product_v_id").val(default_variant);
					}else{
						var permalink = '/cart/'+default_variant+':1';

						$(".wk_main_product_v_id").val(default_variant);
					}
				}
			}else if(redirect_page == 2){
				if(wk_active_block){
					// var permalink = '/cart/add?id[]='+default_variant+'&id[]='+wk_active_block;

					var permalink = `/cart/add?items[0][id]=${default_variant}&items[1][id]=${wk_active_block}&items[1][properties][_wk_main_product_id]=${default_variant}`;

					$(".wk_active_block_v_id").val(wk_active_block);
					$(".wk_main_product_v_id").val(default_variant);
					$(".wk_checkout_properties").val("_wk_main_product_id");
				}else{
					if(main_id_variant){
						// var permalink = '/cart/add?id[]='+default_variant+'&id[]='+main_id_variant;

						var permalink = `/cart/add?items[0][id]=${default_variant}&items[1][id]=${main_id_variant}&items[1][properties][_wk_main_product_id]=${default_variant}`;

						$(".wk_active_block_v_id").val(main_id_variant);
						$(".wk_main_product_v_id").val(default_variant);
						$(".wk_checkout_properties").val("_wk_main_product_id");

					}else{
						var permalink = '/cart/add?id[]='+default_variant;

						$(".wk_main_product_v_id").val(default_variant);
					}
				}
			}
			
			$(".wk_warranty_btn").attr("href",permalink);
			}else{
			$('.wk_warranty_btn').removeAttr("href");
			}
			$('.wk_damage_des').html($(this).children('.wk_damage_warr_desc').html()).hide();
		});

		if($(".wk_warranty_product").length > 0)
		{
			var product_id= $(".wk_warranty_product").attr("product_id");
			var product_type = $(".wk_warranty_product").attr("product_type");
			product_variantId = $(".wk_warranty_product").attr("product_variants");
			var url = WARRANTY.api_url+"admin/warranty_front_product";
			getExtendedWarranty(url,product_id);
		}
	});

		$('body').on('click','.warranty_filter',function() {
			var search_p_id = $(this).parents('.wk_main_warranty_container').find('#warranty_search_pid').children('input').val();
			var search_p_name = $(this).parents('.wk_main_warranty_container').find('#warranty_search_pname').children('input').val();
			var search_p_date = $(this).parents('.wk_main_warranty_container').find('#warranty_search_pdate').children('input').val();
			var search_p_duration = $(this).parents('.wk_main_warranty_container').find('#warranty_search_duration').children('input').val();
			var search_p_status = $(this).parents('.wk_main_warranty_container').find('#warranty_search_status').children('input').val();
			var search_s_no = $(this).parents('.wk_main_warranty_container').find('#warranty_search_sno').children('input').val();
			var warranty_search_platform=$(this).parents('.wk_main_warranty_container').find('#warranty_search_platform').children('input').val();
			var id_customer = $('#customer_id').val();
			if(search_p_id || search_p_name || search_p_date || search_p_duration || search_p_status || search_s_no || warranty_search_platform) {
			// if(wk_warranty_search_td){
				$.ajax({
					type:'POST',
					url : WARRANTY.api_url+"admin/warranty_front_detail",
					jsonpCallback :"FILTER",
					dataType: "jsonp",
					crossDomain: true,
					data:{
						search_p_id:search_p_id,
						search_p_name:search_p_name,
						search_p_date:search_p_date,
						search_p_duration:search_p_duration,
						search_p_status:search_p_status,
						search_s_no:search_s_no,
						warranty_search_platform:warranty_search_platform,
						id_customer:id_customer,
						shop_name:WARRANTY.shop_name
					},
					beforeSend: function() {
						$(".wk_front_loader").show();
					},
					success : function(response) {
						// console.log(response);
						$("#wk_warranty_detail").html(response);
					},
					error:function(response){
						// console.log(response);

						console.log("something went wrong");
					},
					complete: function() {
						$(".wk_front_loader").hide();
					}
				});
			}
			else {
				location.reload();
			}
		});

		$("body").on('click','.warranty_reset',function() {
			location.reload();
		});

		$("body").on('click',".wk_dropdown-toggle",function(){
			$(this).parents('tr').siblings('tr').find('td .wk_dropdown-menu').hide();
			$(this).siblings('.wk_dropdown-menu').toggle();
		});

		$("body").on('mouseover',".wk_dropdown-menu span",function(){
			var theme_color = $(".wk_warranty_filter_button").css('background-color');
			$(this).siblings('span').css('background-color','#fff');
			$(this).css('background-color',theme_color);
		});

		$('body').on('click','.wk_warranty_history',function() {
			var id_registered_warranty = $(this).siblings('.registered_warranty_id').val();
			// Ajax Call Here
			var url = WARRANTY.api_url+"admin/extended_warranty_popup";
			response = getRegisteredWarrantyHistory(url,id_registered_warranty);
			$('.wk_product_wise_detail').html(response).show();
			$(this).parents('.wk_dropdown-menu').hide();
			$("#product_list").css("opacity","0.1");

			var offset = $( ".wk_product_wise_detail" ).offset();
			var distance =parseInt(offset.top)-24;
			$("html, body").animate({ scrollTop: distance }, "slow");
			$('.wk_product_wise_detail>.wk_extend').show();
		});

		$('body').on('click','.wk_warranty_damage_protection',function() {
			var id_registered_warranty = $(this).siblings('.registered_warranty_id').val();
			// Ajax Call Here

			$.ajax({
				type:'POST',
				url : WARRANTY.api_url+"admin/extended_warranty_popup",
				async: false,
				crossDomain: true,
				data:{id_registered_warranty:id_registered_warranty, damage_protection:true ,shop_name:WARRANTY.shop_name},
				success:function(response){
					result= response;
					$(".wk_warranty_product").html(response);

					$('.wk_product_wise_detail').html(response).show();
					$(this).parents('.wk_dropdown-menu').hide();
					$("#product_list").css("opacity","0.1");
		
					var offset = $( ".wk_product_wise_detail" ).offset();
					var distance =parseInt(offset.top)-24;
					$("html, body").animate({ scrollTop: distance }, "slow");
					$('.wk_product_wise_detail>.wk_extend').show();

				},
				error:function(response){
					console.log("something went wrong");
				}
			});


		});

		// wk_product_p

		$('body').on('click','.wk_product_page',function() {
			wk_warrnty_id = $(this).find(".wk_warrnty_id").val();
			$.ajax({
				type:'POST',
				url : WARRANTY.api_url+"admin/old_warranty_front",
				async: false,
				crossDomain: true,
				data:{wk_warrnty_id:wk_warrnty_id, shop_name:WARRANTY.shop_name},
				success:function(response){
					console.log(response.product_handle);
					window.location.replace("http://"+WARRANTY.shop_name+"/products/"+response.product_handle);
				},
				error:function(response){
					console.log("something went wrong");
				}
			});
		});


		$('body').on('click','.wk_view_all_serial_no',function() {
			var id_registered_warranty = $(this).siblings('.registered_warranty_id').val();
			// Ajax Call Here

			$.ajax({
				type:'POST',
				url : WARRANTY.api_url+"admin/extended_warranty_popup",
				async: false,
				crossDomain: true,
				dataType:"text",
				data:{id_registered_warranty:id_registered_warranty, product_sr_no:true ,shop_name:WARRANTY.shop_name},
				success:function(response){
					result= response;
					$(".wk_warranty_product").html(response);

					$('.wk_product_wise_detail').html(response).show();
					$(this).parents('.wk_dropdown-menu').hide();
					$("#product_list").css("opacity","0.1");
		
					var offset = $( ".wk_product_wise_detail" ).offset();
					var distance =parseInt(offset.top)-24;
					$("html, body").animate({ scrollTop: distance }, "slow");
					$('.wk_product_wise_detail>.wk_extend').show();

				},
				error:function(response){
					console.log(response);
				}
			});


		});

		$('body').on('click','.wk_warranty_extend_a',function(e) {
			e.preventDefault();
			product_id = $(this).siblings('.id_order_product').val();
			var registered_warranty_id = $(this).siblings('.registered_warranty_id').val();
			var wk_iso_code = WARRANTY.country;
			// Ajax Call Here
			var url = WARRANTY.api_url+"admin/extended_warranty_popup";
			response = getExtendedWarranty(url,product_id,1,registered_warranty_id);
			$('.wk_product_wise_detail').html(response).show();
			$(this).parents('.dropdown-menu').hide();
			$("#product_list").css("opacity","0.1");

			// class name checked added in first warranty variants
			$("#wk_warranty_detail").find('.checked').trigger('click');

			var offset = $( ".wk_product_wise_detail" ).offset();
			var distance =parseInt(offset.top)-24;
			$("html, body").animate({ scrollTop: distance }, "slow");
			$('.wk_product_wise_detail>.wk_extend').show();
		});

		$('body').on('click','.wk_pay_for_claim_warranty',function(e) {
			e.preventDefault();
			$(".wk_warranty_content_error").css("display", "none");
			$(".wk_warranty_content_textarea").css("border-color", "black");
			var wk_claim_registered_warranty_id = $(this).siblings('.wk_claim_warranty_reg_input').val();
			var wk_claim_warranty_order_id 		= $(this).siblings('.wk_claim_warranty_order_input').val();
			var wk_claim_main_product_id 		= $(this).siblings('.wk_claim_warranty_main_id_input').val();
			var wk_warranty_content				= $(".wk_warranty_content_textarea").val();
			var wk_claim_type					= $(".wk_warranty_facilities").find(".wk_active_facilities").find(".wk_warranty_selected_facilitie").val();
			var url = WARRANTY.api_url+"admin/extended_warranty_popup?request=wk_claim_warranty";

			var wk_warranty_content1 = wk_warranty_content.split(" ");
			if(wk_warranty_content1.length > 300) {
				$(".wk_warranty_content_error").css("display", "block");
				$(".wk_warranty_content_textarea").css("border-color", "red");
			} else {
				$.ajax({
					type:'POST',
					url : url,
					async: false,
					crossDomain: true,
					data:{registered_warranty_id:wk_claim_registered_warranty_id,wk_warranty_content:wk_warranty_content,wk_claim_type:wk_claim_type,main_id_product:wk_claim_main_product_id, wk_warranty_order_id:wk_claim_warranty_order_id,shop_name:WARRANTY.shop_name, isoCode:WARRANTY.country},
					success:function(response){
						if (response.status == 'true') {
							window.location = response.invoice_url;
						} else if(response.status == 'false') {
							$(".wk_claim_warranty_msg_error").css("display", "block");

							setTimeout(function(){
								location.reload();
							},3000);
						}
					},
					error:function(response){
						console.log("something went wrong");
					}
				});
			}


		});

		$('body').on('click','.wk_claim_warranty_popup',function(e) {
			e.preventDefault();
			product_id = $(this).siblings('.id_order_product').val();
			var registered_warranty_id = $(this).siblings('.registered_warranty_id').val();
			var wk_warranty_order_id = $(this).siblings('.wk_warranty_order_id').val();
			var url = WARRANTY.api_url+"admin/extended_warranty_popup";
					

			$.ajax({
				type:'POST',
				url : url,
				async: false,
				crossDomain: true,
				data:{registered_warranty_id:registered_warranty_id,main_id_product:product_id, wk_warranty_order_id:wk_warranty_order_id,shop_name:WARRANTY.shop_name,isoCode:WARRANTY.country},
				success:function(response){


					$('.wk_product_wise_detail').html(response).show();
					$(this).parents('.dropdown-menu').hide();
					$("#product_list").css("opacity","0.1");

					// class name checked added in first warranty variants
					$("#wk_warranty_detail").find('.checked').trigger('click');

					var offset = $( ".wk_product_wise_detail" ).offset();
					var distance =parseInt(offset.top)-24;
					$("html, body").animate({ scrollTop: distance }, "slow");
					$('.wk_product_wise_detail>.wk_extend').show();
				},
				error:function(response){


					console.log("something went wrong");
				}
			});




		});

		$('body').on('click','.wk_warranty_replace',function(e) {
			$(".wk_warranty_repair").removeClass("wk_active_facilities");
			$(this).addClass("wk_active_facilities");
		});

		$('body').on('click','.wk_warranty_repair',function(e) {
			$(".wk_warranty_replace").removeClass("wk_active_facilities");
			$(this).addClass("wk_active_facilities");
		});

		$('body').on('mouseup','.wk_warranty_extend_a',function(e) {
			e.preventDefault();
			product_id = $(this).siblings('.id_order_product').val();
			var registered_warranty_id = $(this).siblings('.registered_warranty_id').val();
			// Ajax Call Here
			var url = WARRANTY.api_url+"admin/extended_warranty_popup";
			response = getExtendedWarranty(url,product_id,1,registered_warranty_id);
			$('.wk_product_wise_detail').html(response).show();
			$("#product_list").css("opacity","0.1");

			// class name checked added in first warranty variants
			$("#wk_warranty_detail").find('.checked').trigger('click');

			var offset = $( ".wk_product_wise_detail" ).offset();
			var distance =parseInt(offset.top)-24;
			$("html, body").animate({ scrollTop: distance }, "slow");
			$('.wk_product_wise_detail>.wk_extend').show();
		});

		$("body").on('click','.wk_cross_img_div',function() {
			$(this).parents('.wk_product_wise_detail').hide();
			$(this).parents(".wk_product_wise_detail").siblings('table').css("opacity",'1');
		});

		$("body").on('click','.wk_extend_checkbox',function(){
				if($(this).parents('.extending').hasClass('wk_extended_active')) {
				}
				else {
					$pledge_amount 			= $('input[name=extend_warranty]:checked').val(); //check_variant_price
					warranty_amount 		= $(this).siblings('.wk_warranty_amount').text();
					check_variant_price 	= $(this).siblings('.check_variant_price').val();
					warranty_description 	= $(this).siblings('.warranty_description').html();
					
					$(this).parents(".wk_extend").children('.wk_extend_warr_details').children('.wk_show_description').html(warranty_description).show();
					if(check_variant_price != ""){
						$(this).parents(".wk_extend").children('.wk_extend_warr_details').children('.wk_show_price').html(warranty_amount).show();
					}

					$('.wk_warranty_detail_label').removeClass('wk_extended_active');
					$(this).parent('.extending').siblings('.extending').children('.wk_extend_checkbox').prop('checked', false);
					$('.wk_warranty_detail_label').css('background-color','#FFF');
					if($(this).is(':checked')) {
						$(this).parents('.extending').addClass('wk_extended_active');
						$(this).parents('.extending').siblings('.extending').removeClass('wk_extended_active');
						main_id_variant = $(this).siblings('.main_id_variant').val();
						$(this).siblings('.wk_warranty_detail_label').css('background-color','#D2D2D2');
						$('.wk_extend_warranty_button').css('opacity','1.5');
						$('.wk_pop_up_extend_button').css('opacity','1.5');
					}
					else{
						main_id_variant = 0;
						$('.wk_extend_warranty_button').css('opacity','0.2');
						$('.wk_pop_up_extend_button').css('opacity','0.2');
						$(this).parents(".wk_extend").children('.wk_show_price').hide();
						$(this).parents(".wk_extend").children('.wk_show_description').hide();
					}
					var registered_warranty_id = $(".registered_product_id").val();
					// var permalink = '/cart/'+main_id_variant+':1?attributes[id_order_product]='+registered_warranty_id;
					var wk_protection_active = $(".wk_protection_active").find(".damage_protection_main_id_variant").val();

					var redirect_page = $('.redirect_page').val();
					if(redirect_page == 1){
						if(wk_protection_active){
							var permalink = '/cart/'+main_id_variant+':1,'+wk_protection_active+':1?attributes[id_order_product]='+registered_warranty_id+'&attributes[wk_warranty]=true';
						}else{
							var permalink = '/cart/'+main_id_variant+':1?attributes[id_order_product]='+registered_warranty_id;
						}
					}else if(redirect_page == 2){
						if(wk_protection_active){
							var permalink = '/cart/add?id[]='+wk_protection_active+'&id[]='+main_id_variant+'&attributes[id_order_product]='+registered_warranty_id+'&attributes[wk_warranty]=true';
						}else{
							var permalink = '/cart/add?id[]='+main_id_variant+'&attributes[id_order_product]='+registered_warranty_id;
						}
					}else{
						if(wk_protection_active){
							var permalink = '/cart/'+main_id_variant+':1,'+wk_protection_active+':1?attributes[id_order_product]='+registered_warranty_id+'&attributes[wk_warranty]=true';
						}else{
							var permalink = '/cart/'+main_id_variant+':1?attributes[id_order_product]='+registered_warranty_id;
						}
					}

					var damage_protection_check_variant_price =0;
					var check_variant_price = 0;
					var wk_store_currency = $(".wk_store_currency").val();
					if($(".wk_damage_warr_checkbox_opt").is(":checked")){
						var damage_protection_check_variant_price 	= parseFloat($(".wk_protection_active").find(".damage_protection_check_variant_price").val()).toFixed(2);
						if(!$.isNumeric(damage_protection_check_variant_price)){
							damage_protection_check_variant_price = 0.00;
						}
					}

					if($(".wk_extend_warr_checkbox_opt").is(":checked")){
						var check_variant_price = parseFloat($(".wk_extended_active").find(".check_variant_price").val()).toFixed(2);
					}

					if(damage_protection_check_variant_price && check_variant_price){
						total_price = parseFloat(damage_protection_check_variant_price) + parseFloat(check_variant_price);
					}else if(damage_protection_check_variant_price){
						total_price = damage_protection_check_variant_price;
					}else{
						total_price = check_variant_price;
					}
					$(".wk_total_price").html(wk_store_currency+" "+total_price);

					// $(".wk_pop_up_extend_button").parents(".anc").attr("href",permalink);
				}
		});

		$("body").on('click','.wk_damage_protection_checkbox',function(){
			if($(this).parents('.extending').hasClass('wk_protection_active')) {
			}
			else {
				$pledge_amount 			= $('input[name=damage_protection_warranty]:checked').val(); //check_variant_price
				warranty_amount 		= $(this).siblings('.wk_damage_protection_warranty_amount').text();
				check_variant_price 	= $(this).siblings('.damage_protection_check_variant_price').val();
				warranty_description 	= $(this).siblings('.warranty_damage_protection_description').text();
				
				$(this).parents(".wk_extend").children('.wk_damage_warr_details').children('.wk_warranty_protection_show_description').html(warranty_description).show();
				if(check_variant_price != ""){
					$(this).parents(".wk_extend").children('.wk_damage_warr_details').children('.wk_warranty_protection_show_price').html(warranty_amount).show();
				}
				
				$('.wk_damage_protection_warranty_detail_label').removeClass('wk_protection_active');
				$(this).parent('.extending').siblings('.extending').children('.wk_damage_protection_checkbox').prop('checked', false);
				$('.wk_damage_protection_warranty_detail_label').css('background-color','#FFF');
				if($(this).is(':checked')) {
					$(this).parents('.extending').addClass('wk_protection_active');
					$(this).parents('.extending').siblings('.extending').removeClass('wk_protection_active');
					main_id_variant = $(this).siblings('.damage_protection_main_id_variant').val();
					$(this).siblings('.wk_damage_protection_warranty_detail_label').css('background-color','#D2D2D2');
					$('.wk_extend_warranty_button').css('opacity','1.5');
					$('.wk_pop_up_extend_button').css('opacity','1.5');
				}
				else{
					main_id_variant = 0;
					$('.wk_extend_warranty_button').css('opacity','0.2');
					$('.wk_pop_up_extend_button').css('opacity','0.2');
					$(this).parents(".wk_extend").children('.wk_warranty_protection_show_price').hide();
					$(this).parents(".wk_extend").children('.wk_warranty_protection_show_description').hide();
				}
				var registered_warranty_id = $(".registered_product_id").val();
				// var permalink = '/cart/'+main_id_variant+':1?attributes[id_order_product]='+registered_warranty_id;
				var wk_extended_active = $(".wk_extended_active").find(".main_id_variant").val();

				var redirect_page = $('.redirect_page').val();
				if(redirect_page == 1){
					if(wk_extended_active){
						var permalink = '/cart/'+main_id_variant+':1,'+wk_extended_active+':1?attributes[id_order_product]='+registered_warranty_id+'&attributes[wk_warranty]=true';
					}else{
						var permalink = '/cart/'+main_id_variant+':1?attributes[id_order_product]='+registered_warranty_id;
					}
				}else if(redirect_page == 2){
					if(wk_extended_active){
						var permalink = '/cart/add?id[]='+wk_extended_active+'&id[]='+main_id_variant+'&attributes[id_order_product]='+registered_warranty_id+'&attributes[wk_warranty]=true';
					}else{
						var permalink = '/cart/add?id[]='+main_id_variant+'&attributes[id_order_product]='+registered_warranty_id;
					}
				}else{
					if(wk_extended_active){
						var permalink = '/cart/'+main_id_variant+':1,'+wk_extended_active+':1?attributes[id_order_product]='+registered_warranty_id+'&attributes[wk_warranty]=true';
					}else{
						var permalink = '/cart/'+main_id_variant+':1?attributes[id_order_product]='+registered_warranty_id;
					}
				}

				// $(".wk_pop_up_extend_button").parents(".anc").attr("href",permalink);
				var damage_protection_check_variant_price =0;
				var check_variant_price = 0;
				var wk_store_currency = $(".wk_store_currency").val();
				if($(".wk_damage_warr_checkbox_opt").is(":checked")){
					var damage_protection_check_variant_price 	= parseFloat($(".wk_protection_active").find(".damage_protection_check_variant_price").val()).toFixed(2);
					if(!$.isNumeric(damage_protection_check_variant_price)){
						damage_protection_check_variant_price = 0.00;
					}
				}

				if($(".wk_extend_warr_checkbox_opt").is(":checked")){
					var check_variant_price = parseFloat($(".wk_extended_active").find(".check_variant_price").val()).toFixed(2);
				}

				if(damage_protection_check_variant_price && check_variant_price){
					total_price = parseFloat(damage_protection_check_variant_price) + parseFloat(check_variant_price);
				}else if(damage_protection_check_variant_price){
					total_price = damage_protection_check_variant_price;
				}else{
					total_price = check_variant_price;
				}
				$(".wk_total_price").html(wk_store_currency+" "+total_price);	
				
			}
		});

		$("body").on("click", ".wk_pop_up_extend_button", function(){
			var registered_warranty_id = $(".registered_product_id").val();
			var wk_extended_active   = false;
			var wk_protection_active = false;

			if($(".wk_extend_warr_checkbox_opt").is(":checked")){
				wk_extended_active = $(".wk_extended_active").find(".main_id_variant").val();
			}
			
			if($(".wk_damage_warr_checkbox_opt").is(":checked")){
				wk_protection_active = $(".wk_protection_active").find(".damage_protection_main_id_variant").val();
			}

			var redirect_page = $('.redirect_page').val();
			if(redirect_page == 1){
				if(wk_extended_active && wk_protection_active){
					var permalink = '/cart/'+wk_protection_active+':1,'+wk_extended_active+':1?attributes[id_order_product]='+registered_warranty_id+'&attributes[wk_warranty]=true';
				}else if(wk_protection_active){
					var permalink = '/cart/'+wk_protection_active+':1?attributes[id_order_product]='+registered_warranty_id;
				}else if(wk_extended_active){
					var permalink = '/cart/'+wk_extended_active+':1?attributes[id_order_product]='+registered_warranty_id;
				}
			}else if(redirect_page == 2){
				if(wk_extended_active && wk_protection_active){
					var permalink = '/cart/add?id[]='+wk_extended_active+'&id[]='+wk_protection_active+'&attributes[id_order_product]='+registered_warranty_id+'&attributes[wk_warranty]=true';
				}else if(wk_protection_active){
					var permalink = '/cart/add?id[]='+wk_protection_active+'&attributes[id_order_product]='+registered_warranty_id;
				}else if(wk_extended_active){
					var permalink = '/cart/add?id[]='+wk_extended_active+'&attributes[id_order_product]='+registered_warranty_id;
				}
			}else{
				if(wk_extended_active && wk_protection_active){
					var permalink = '/cart/'+main_id_variant+':1,'+wk_extended_active+':1?attributes[id_order_product]='+registered_warranty_id+'&attributes[wk_warranty]=true';
				}else if(wk_protection_active){
					var permalink = '/cart/'+wk_protection_active+':1?attributes[id_order_product]='+registered_warranty_id;
				}else if(wk_extended_active){
					var permalink = '/cart/'+wk_extended_active+':1?attributes[id_order_product]='+registered_warranty_id;
				}
			}
			if(permalink){
				window. location. replace(permalink); 
			}else{
				console.log("No Permalink");
			}
		});

		// $(document).on("change",".single-option-selector",function() {
		//   var productSelect = document.getElementById("ProductSelect-product-template");
		//   product_variantId = productSelect.options[productSelect.selectedIndex].value;
		// });

		// $("body").on("click",".wk_extend_warranty_button",function(e){
		$("body").on("click",".proceed_for_extend",function(e){
			e.preventDefault();
			// var main_id_customer = $(this).parents('.wk_warranty_product').attr('main_id_customer');
			// var product_id = $(this).parents('.wk_warranty_product').attr('product_id');
			var main_id_customer = $(this).parents('.wk_default_warranty').attr('customer_id');
			var product_id = $(this).parents('.wk_default_warranty').attr('product_id');
			$.ajax({
				type:'POST',
				url : WARRANTY.api_url+"admin/warranty_front_detail",
				jsonpCallback :"check_product",
				dataType: "jsonp",
				crossDomain: true,
				data:{customer_id:main_id_customer,product_id:product_id,shop_name:WARRANTY.shop_name},
				success:function(response){
					// console.log(response);
					if(response) {
					window.location = '../pages/warranty-detail';
					}
					else {
						$('.wk_extend_warranty_button').children('.first_registered').remove();
						var newdiv = $( "<div class='first_registered'>please registered product first</div>" );
						$('.wk_extend_warranty_button').append(newdiv);
					}
				},
				error:function(response){
					console.log("something went wrong");
				}
			});

			$(this).addClass('active');
			$(this).removeClass('wk_extend_warranty_button');
			if(main_id_variant){
				// addToCart(main_id_variant);

				// addToCart(product_variantId);
				// for(i=0;i<2;i++) {
				//   if(i == 0 ) {
				//     addToCart(product_variantId);
				//   }
				//   else{
				//     addToCart(main_id_variant);
				//   }
				// }
			}
			$(this).removeClass('active');
			$(this).addClass('wk_extend_warranty_button');
		});

		$("body").on('click','.try',function(e) {
			e.preventDefault();
			$variant_id = $(this).attr('href');
			id_order_product = $(this).siblings('input').val();
			// addToCart($variant_id,id_order_product);
			window.location.href = '/cart/'+$variant_id+':1?attributes[id_order_product]='+id_order_product;
		});

		$("body").on("click",".view_record",function(){
			$offset = $("#view_rewards").offset();
			$('html, body').animate({scrollTop: $('#view_rewards').offset().top -100 }, 'slow');
		});

		$("body").on("click","td>img",function() {
			var title = $(this).attr("data");

			var topdiv = $(this).parents('.wk_extend_all_warranty').offset();
			var distance_topdiv = parseInt(topdiv.top);
			var offset = $(this).offset();
			var position = $(this).position();
			var distance = parseInt(position.top);
			var left = parseInt(position.left);
			var final_distance = distance-distance_topdiv;
			$(this).parents('.wk_extend_all_warranty').children('.tooltip').css({'top':distance-4,'left':left+20});
			$(this).parents('.wk_extend_all_warranty').children('.tooltip').html(title).toggle();
		});

		$("body").on("mouseover","td>img",function(e) {
			e.preventDefault();
			var title = $(this).attr("data");

			var topdiv = $(this).parents('.wk_extend_all_warranty').offset();
			var distance_topdiv =parseInt(topdiv.top);
			var offset = $(this).offset();
			var position = $(this).position();
			var distance = parseInt(position.top);
			var left = parseInt(position.left);
			var final_distance = distance-distance_topdiv;
			$(this).parents('.wk_extend_all_warranty').children('.tooltip').css({'top':distance-4,'left':left+20});
			$(this).parents('.wk_extend_all_warranty').children('.tooltip').html(title).toggle();
		});

		$("body").on("click",".wk_warranty_address_span",function() {
			wk_warranty_address_text = $(".wk_warranty_address_text");
			copyToClipboard(wk_warranty_address_text);
			$(this).text("Copyed");
			setTimeout(function(){
				$(this).text("Copy");
			},3000);
		});

		// if($('body').find('.wk_remove_button').length > 0){
		// 	alert();
		// 	if($(".wk_main_extend_warranty").length > 0){
		// 		setTimeout(
		// 	  function() 
		// 	  {alert('here');
		// 	    $('.wk_warranty_btn').hide();
		// 	  }, 2000);
		// 	}	
		// }

		
		// $("body").on("mouseleave","td>img",function(e) {
		// 	e.preventDefault();
		// 	var title = $(this).attr("title");
		//
		// 	var topdiv = $(this).parents('.wk_extend_all_warranty').offset();
		// 	var distance_topdiv =parseInt(topdiv.top);
		// 	var offset = $(this).offset();
		// 	var distance =parseInt(offset.top);
		// 	var final_distance = distance-distance_topdiv;
		// 	$(this).parents('.wk_extend_all_warranty').children('.tooltip').css('top',final_distance);
		// 	$(this).parents('.wk_extend_all_warranty').children('.tooltip').html(title).hide();
		// });

	}).call(this);

	function copyToClipboard(element) {
		var $temp = $("<input>");
		$("body").append($temp);
		$temp.val($(element).val()).select();
		document.execCommand("copy");
		$temp.remove();
	  }

	function getWarrantyDetail(customer_id,offset,record_no) {
		$.ajax({
			type:'POST',
			url : WARRANTY.api_url+"admin/warranty_front_detail",
			jsonpCallback :"warranty_detail",
			dataType: "jsonp",
			crossDomain: true,
			data:{customer_id:customer_id,offset:offset,record_no:record_no,shop_name:WARRANTY.shop_name},
			beforeSend: function() {
				$(".wk_front_loader").show();
			},
			success:function(response){
				// console.log(response);
				$("#wk_warranty_detail").html(response);
			},
			complete:function() {
				$(".wk_front_loader").hide();
			},
			error:function(response){
				console.log("something went wrong");
			}
		});
	}

	function isValidForOldWarranty(order_id) {
		$.ajax({
			type: 'POST',
			url : WARRANTY.api_url+"admin/old_warranty_front",
			// jsonpCallback :"old_warranty",
			dataType: "jsonp",
			crossDomain: true,
			data:{order_id:order_id,shop_name:WARRANTY.shop_name, isoCode:WARRANTY.country},
			beforeSend: function() {
				$(".wk_front_loader").show();
			},
			success:function(response){
				$('#main_popup_div').show();
				$("#main_popup_div").css("top","0");
				$("#main_popup_div").css("bottom","0");
				$("#main_popup_div").css("left","0");
				$("#main_popup_div").css("right","0");

				$("#main_popup_div").html(response);
				$(".main_popup_div").css("position","absolute");
				$("#main_popup_div").css("position","absolute");

				// $(".main_popup_div").css("left","40px");
				$(".main_popup_div").css("margin-top","6%");
			},
			complete:function() {
				$(".wk_front_loader").hide();
			},
			error:function(response){
				console.log(response);
			}
		})
	}


	function closePopup(){
		// $("#main_popup_div").css("display", "block");
		$('#main_popup_div>.main_popup_div').hide();
		$('#main_popup_div').hide();
	}

	$("body").on("click", "#wk_closs_popup", function(){
		$('#main_popup_div>.main_popup_div').hide();
		$('#main_popup_div').hide();
		$('.wk_old_warranty_btn').prop('disabled', false);
	});


	function payNow(mani_product_id) {
		$.ajax({
		type: 'POST',
		url : WARRANTY.api_url+"admin/old_warranty_front_popup",
		// jsonpCallback :"old_warranty",
		dataType: "jsonp",
		crossDomain: true,
		data:{mani_product_id:mani_product_id,shop_name:WARRANTY.shop_name ,isoCode:WARRANTY.country},
		beforeSend: function() {
			$(".wk_front_loader").show();
		},
		success:function(response){
			console.log(response);
			$(".wk_warranty_for_old").css("display", "block");
			$(".wk_warranty_for_old").html(response);
			$('.wk_warranty_for_old>.wk_extend').show();
			$('#main_popup_div>.main_popup_div').hide();
			$(".main_popup_div").css("opacity","0.1");
			$("#wk_extend").css("Blend","Pass through");
			// $("#main_Old_popup").css("display", "block");
			
			// getOldData(response);
			// $("#wk_old_warranty").html(response);
		},
		complete:function() {
			$(".wk_front_loader").hide();
		},
		error:function(response){
			console.log("something went wrong");
			console.log(response);
		}
		});
	};



	function getExtendedWarranty(url,product_id,front=false,registered_warranty_id= false) {
		if(product_id)
		{
			if(registered_warranty_id) {
				var data = {registered_warranty_id:registered_warranty_id,main_id_product:product_id,shop_name:WARRANTY.shop_name,isoCode:WARRANTY.country}
			}
			else {
				var data = {main_id_product:product_id,shop_name:WARRANTY.shop_name,isoCode:WARRANTY.country}
			}
			result = 0;
			$.ajax({
				type:'POST',
				url : url,
				async: false,
				crossDomain: true,
				data:data,
				success:function(response){
					result= response;
					if(front) {
						result= response;
					}
					else {
						$(".wk_warranty_product").html(response);
					}
				},
				error:function(response){


					console.log("something went wrong");
				}
			});
			if(result) {
				return result;
			}
		}
	}


	function checkInCart(wk_prod_id=false) {
		let wk_item_check = false;
		let shop_base_url = location.origin;
		jQuery.ajax({
			type: 'GET',
			url: shop_base_url+"/cart.js",
			dataType: "json",
			contentType: "application/json",
			async: false,
			success: function (response) {
				response.items.forEach(element => {
					if(wk_prod_id == element.id){
						wk_item_check=true;
					}
				});
			}
		});
		return wk_item_check;
	}

	function checkProduct (wk_main_product_v_id) {
		let wk_variant_array = [];
		let shop_base_url = location.origin;
		jQuery.ajax({
			type: 'GET',
			url: shop_base_url+"/cart.js",
			dataType: "json",
			contentType: "application/json",
			async: false,
			success: function (response) {
				response.items.forEach(element => {
					console.log(`product id is ${element.properties._wk_main_product_id}`);
					if(element.properties != undefined && element.properties != null && element.properties._wk_main_product_id != undefined && element.properties._wk_main_product_id != null){
						var wk_product_id = element.properties._wk_main_product_id;

						if (wk_product_id == wk_main_product_v_id) {
							wk_variant_array.push((element.variant_id).toString());
						}
					}
				});
			}
		});

		console.log(wk_variant_array);
		return wk_variant_array;
	}

	function checkProductQuantity (wk_main_product_v_id) {
		let wk_variant_qty = 0;
		let shop_base_url = location.origin;
		jQuery.ajax({
			type: 'GET',
			url: shop_base_url+"/cart.js",
			dataType: "json",
			contentType: "application/json",
			async: false,
			success: function (response) {
				response.items.forEach(element => {
					wk_variant_qty = element
					if(element.variant_id == wk_main_product_v_id){
						wk_variant_qty = element.quantity;
					}
				});
			}
		});
		console.log(wk_variant_qty);
		return wk_variant_qty;
	}

	function getRegisteredWarrantyHistory(url,id_registered_warranty) {
		result = 0;
		$.ajax({
			type:'POST',
			url : url,
			async: false,
			crossDomain: true,
			data:{id_registered_warranty:id_registered_warranty,shop_name:WARRANTY.shop_name},
			success:function(response){
				result= response;
				$(".wk_warranty_product").html(response);
			},
			error:function(response){
				console.log("something went wrong");
			}
		});
		if(result) {
			return result;
		}
	}

	function addToCart(variant_id,id_order_product)
	{
	// jQuery.post('/cart/clear.js');
	setTimeout(function(){
		jQuery.post('/cart/add.js', {
		quantity: 1,
		id: variant_id,
				properties: {
				'id_order_product': id_order_product
			},
				attributes: {
					'id_order_product': id_order_product
				}
		});
	},200);
	setTimeout(function(){
			window.open("/cart","_top");
		},2400);
	}

	function cartDetail() 
	{
	price = 0;
	$.ajax({
		type:'GET',
		url :"/cart.js",
		dataType: "json",
		contentType:"application/json",
		async: false,
		success:function(response){
		console.log(response);
		item_count = response['item_count'];
		items = response['items'];
		}
	});
		items_and_count = {}
		items_and_count ["item_count"] = item_count;
		items_and_count ["items"] = items;
		return items_and_count;
	}
}